/* ON Móveis · modelo 3D da linha na ficha do produto (v164)
   ────────────────────────────────────────────────────────────────────
   O bloco nasce com a imagem do móvel montado (HTML puro). Quando chega
   perto da tela, carrega o three.js e o modelo da linha (assets
   onm-3d-<linha>.js, gerados do DWG da marcenaria) e troca a imagem
   pelo desenho 3D. A rolagem abre as gavetas e desmonta o móvel, o dedo
   gira e as bolinhas trocam a cor. Se o aparelho não tiver WebGL, a
   imagem fica e o bloco encolhe para o tamanho normal. */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-p3d]');
  if (!raiz) return;
  var REDUZ = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // "Ver na minha casa": usa o 3D enviado como mídia do produto no Shopify. O botão
  // só aparece em celular que abre realidade aumentada (o ShopifyXR tira o hidden).
  /* v200: no iPhone o móvel abre travado no tamanho real (o Quick Look não deixa
     aumentar nem diminuir com os dedos). Vale para o 3D da página e para o de outra
     combinação montada no bloco. */
  function tamanhoReal(m) {
    var c = JSON.parse(JSON.stringify(m));
    (c.sources || []).forEach(function (s) {
      if (s.format === 'usdz' && s.url && s.url.indexOf('allowsContentScaling') < 0) s.url += (s.url.indexOf('#') < 0 ? '#' : '&') + 'allowsContentScaling=0';
    });
    return c;
  }
  window.__onmTamanhoReal = tamanhoReal;
  (function ligaAR() {
    var js = raiz.querySelector('[data-p3d-xr]'); if (!js) return;
    function prepara() {
      try { window.ShopifyXR.addModels(JSON.parse(js.textContent).map(tamanhoReal)); window.ShopifyXR.setupXRElements(); } catch (e) {}
    }
    if (window.ShopifyXR) { prepara(); return; }
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'shopify-xr', version: '1.0', onLoad: function (erro) {
        if (erro) return;
        if (window.ShopifyXR) prepara(); else document.addEventListener('shopify_xr_initialized', prepara);
      } }]);
    }
  })();

  function semTresD() { raiz.classList.add('p3d--sem3d'); }
  function temWebGL() {
    try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); }
    catch (e) { return false; }
  }
  if (!temWebGL()) { semTresD(); return; }

  function carrega(src) {
    return new Promise(function (ok, erro) {
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = ok; s.onerror = erro; document.head.appendChild(s);
    });
  }
  var iniciou = false;
  function inicia() {
    if (iniciou) return; iniciou = true;
    var chave = raiz.getAttribute('data-chave');
    var promessas = [];
    if (!window.THREE) promessas.push(carrega(raiz.getAttribute('data-three')));
    if (!(window.ONM3D && window.ONM3D[chave])) promessas.push(carrega(raiz.getAttribute('data-modelo')));
    // o kit: lista de peças (modelo, altura da base em mm, deslocamento para o lado)
    var kit = [];
    try { kit = JSON.parse(raiz.getAttribute('data-kit') || '[]'); } catch (e) { kit = []; }
    kit.forEach(function (k) { if (!(window.ONM3D && window.ONM3D[k.k])) promessas.push(carrega(k.u).catch(function () {})); });
    Promise.all(promessas).then(function () {
      if (!window.THREE || !window.ONM3D || !window.ONM3D[chave]) throw new Error('modelo');
      var D = window.ONM3D[chave];
      raiz.__kit = kit;
      kit.forEach(function (k, i) { if (window.ONM3D[k.k]) D = junta(D, window.ONM3D[k.k], { y: k.y, x: k.x, i: i + 1, e: k.e }); });
      monta(JSON.parse(JSON.stringify(D)));
    }).catch(function () { semTresD(); });
  }
  /* v190: troca a medida só no 3D (a página continua a mesma). Carrega o modelo e o kit
     da outra medida, desmonta o 3D atual sem deixar nada ligado e monta o novo. */
  var trocando = false;
  function trocaModelo(op) {
    if (trocando) return; trocando = true;
    var promessas = [];
    if (!(window.ONM3D && window.ONM3D[op.k])) promessas.push(carrega(op.u));
    (op.kit || []).forEach(function (k) { if (!(window.ONM3D && window.ONM3D[k.k])) promessas.push(carrega(k.u).catch(function () {})); });
    raiz.classList.add('p3d--trocando');
    Promise.all(promessas).then(function () {
      var D = window.ONM3D[op.k]; if (!D) throw new Error('modelo');
      D = JSON.parse(JSON.stringify(D)); if (op.espelha) espelha(D);
      raiz.__kit = op.kit || []; raiz.__espelha = !!op.espelha;
      (op.kit || []).forEach(function (k, i) { if (window.ONM3D[k.k]) D = junta(D, window.ONM3D[k.k], { y: k.y, x: k.x, i: i + 1, e: k.e }); });
      if (raiz.__destroi) raiz.__destroi();
      raiz.setAttribute('data-chave', op.k); raiz.setAttribute('data-config', op.cfg); raiz.setAttribute('data-cor', op.cor);
      raiz.setAttribute('data-cores', op.cores); raiz.setAttribute('data-nome', op.n);
      var fr = raiz.querySelector('[data-p3d-frase]'); if (fr) fr.textContent = op.n;
      raiz.__trocou = true;
      monta(JSON.parse(JSON.stringify(D)));
    }).catch(function () {}).then(function () { trocando = false; raiz.classList.remove('p3d--trocando'); });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { io.disconnect(); inicia(); } });
    }, { rootMargin: '900px 0px' });
    io.observe(raiz);
  } else inicia();

  /* v195: a peça espelhada no eixo x, com a porta abrindo para o outro lado (armário de 60
     montado com a dobradiça à direita, ou o segundo armário do Milano 120) */
  function espelha(M) {
    Object.keys(M.pecas).forEach(function (h) {
      var pc = M.pecas[h], p = pc.p.slice(), I = pc.i.slice(), n = pc.n ? pc.n.slice() : null, t, a;
      for (t = 0; t < p.length; t += 3) p[t] = -p[t];
      for (t = 0; t < I.length; t += 3) { a = I[t + 1]; I[t + 1] = I[t + 2]; I[t + 2] = a; }
      if (n) for (t = 0; t < n.length; t += 3) n[t] = -n[t];
      M.pecas[h] = n ? { p: p, i: I, n: n } : { p: p, i: I };
    });
    Object.keys(M.portas || {}).forEach(function (g) { var pt = M.portas[g]; if (pt.tipo !== 'x') { pt.eixo = [-pt.eixo[0], pt.eixo[1]]; pt.ang = -pt.ang; } });
    Object.keys(M.explode || {}).forEach(function (g) { var e = M.explode[g]; M.explode[g] = [-e[0], e[1], e[2]]; });
    return M;
  }
  // o kit: o acessório vai na parede (fundo encostado no fundo do móvel), centrado e
  // com a parte de baixo na altura do kit; abre por último e sobe na desmontagem
  function junta(M, A, esp) {
    esp = esp || {};
    var D = JSON.parse(JSON.stringify(M)), a = JSON.parse(JSON.stringify(A)), px = 'ac' + (esp.i || 1) + '_';
    if (esp.e) espelha(a);
    function lim(pc, eixo, f) { var v = f === 'min' ? Infinity : -Infinity; Object.keys(pc).forEach(function (h) { var p = pc[h].p; for (var i = eixo; i < p.length; i += 3) v = f === 'min' ? Math.min(v, p[i]) : Math.max(v, p[i]); }); return v; }
    var fundoM = lim(M.pecas, 2, 'min'), fundoA = lim(a.pecas, 2, 'min'), baseA = lim(a.pecas, 1, 'min');
    var alturaY = esp.y != null ? esp.y : (M.acessorioY || (lim(M.pecas, 1, 'max') + 150));
    var dy = alturaY - baseA, dz = fundoM - fundoA, dx = esp.x || 0;
    var nP = (D.passos || []).length, sobe = 0;
    Object.keys(D.explode || {}).forEach(function (g) { sobe = Math.max(sobe, D.explode[g][1]); });
    // a TV que vem pendurada no painel substitui a que fica em pé no rack
    if (a.grupos.tv && D.grupos.tv) { delete D.grupos.tv; }
    if (a.grupos.tv) D.tvApoio = a.tvApoio || 'centro';
    Object.keys(a.pecas).forEach(function (h) {
      var p = a.pecas[h].p.slice(); for (var i = 0; i < p.length; i += 3) { p[i] += dx; p[i + 1] += dy; p[i + 2] += dz; }
      D.pecas[px + h] = { p: p, i: a.pecas[h].i, n: a.pecas[h].n };
      var mk = a.mat[h] || 'mdf';
      // armários e espelheiras são brancos em qualquer kit; Paris, Moscou, prateleiras e painéis seguem a cor do móvel;
      // v194: no espelho com LED, só a prancha de cima segue a cor do gabinete
      var segueG = (a.segueCorGrupos || []).some(function (g) { return (a.grupos[g] || []).indexOf(h) > -1; });
      if (!a.segueCor && !segueG && (mk === 'mdf' || mk === 'frt' || mk === 'tmp')) mk = 'acb';
      D.mat[px + h] = mk;
    });
    Object.keys(a.grupos).forEach(function (g) {
      D.grupos[px + g] = a.grupos[g].map(function (h) { return px + h; });
      var e = (a.explode && a.explode[g]) || [0, 0, 0]; D.explode[px + g] = [e[0] + dx * .15, e[1] + sobe + 300, e[2] - 120];
      var pt = a.portas && a.portas[g];
      if (pt) {
        D.portas = D.portas || {};
        D.portas[px + g] = { passo: nP + pt.passo, tipo: pt.tipo, ang: pt.ang, dobr: a.dobradicas || 2,
          eixo: pt.tipo === 'x' ? [pt.eixo[0] + dy, pt.eixo[1] + dz] : [pt.eixo[0] + dx, pt.eixo[1] + dz] };
      }
    });
    if (a.portas && Object.keys(a.portas).length) D.passos = (D.passos || []).concat(a.passos || []);
    D.medAc = D.medAc || {}; D.medAc[px.slice(0, -1)] = a.medidas || null;   // v191
    // v192: prateleira em cima de prateleira (kit de 2 ou 3) sai e encaixa junto com a de baixo
    if (a.gaveta && a.gavetaJunto && M.gavetaJunto) Object.keys(a.gaveta).forEach(function (g) { D.gaveta = D.gaveta || {}; D.gaveta[px + g] = [a.gaveta[g][0], a.gaveta[g][1]]; });
    D.legendas = (D.legendas || []).concat((a.legendas || []).map(function (l) { return [px + l[0], l[1], l[2]]; }));
    if (D.configs) Object.keys(D.configs).forEach(function (c) { D.configs[c] = D.configs[c].slice(); });
    D.suspenso = true;
    return D;
  }

  function monta(D) {
    // v190: o que esta montagem liga fica anotado, para a troca de medida desmontar sem sobras
    var LIGS = [], OBS = [], morto = false;
    function liga(el, ev, fn, op) { el.addEventListener(ev, fn, op); LIGS.push([el, ev, fn, op]); }
    var palco = raiz.querySelector('[data-p3d-palco]'), trilho = raiz.querySelector('[data-p3d-trilho]');
    var img = palco.querySelector('img'), rots = raiz.querySelector('[data-p3d-rots]'), dica = raiz.querySelector('[data-p3d-dica]');
    var etapa = raiz.querySelector('[data-p3d-etapa]'), tit = raiz.querySelector('[data-p3d-tit]');
    var lPassos = raiz.querySelector('[data-p3d-passos]'), lPecas = raiz.querySelector('[data-p3d-pecas]');
    var barra = raiz.querySelector('[data-p3d-barra]'), navs = raiz.querySelectorAll('[data-p3d-modo]'), caixaCores = raiz.querySelector('[data-p3d-cores]');
    var nome = raiz.getAttribute('data-nome') || '';
    var THREE = window.THREE;

    // configuração do anúncio: o que aparece em cima do móvel (pia, tampo, cuba) vem da ficha
    var cfgPedida = raiz.getAttribute('data-config') || '', CONF = D.configs || { unico: [] };
    var cfg = CONF[cfgPedida] ? cfgPedida : (D.configPadrao || Object.keys(CONF)[0]);
    var ESCONDE = {}; (CONF[cfg] || []).forEach(function (g) { ESCONDE[g] = true; });
    D.legendas = D.legendas.filter(function (l) { return !ESCONDE[l[0]] && D.grupos[l[0]]; });
    // listas e cores vêm do modelo
    if (lPassos) lPassos.innerHTML = D.passos.map(function (x, i) { return '<li><b>' + (i + 1) + '</b><div><strong>' + x[0] + '</strong><span>' + x[1] + '</span></div></li>'; }).join('');
    if (lPecas) lPecas.innerHTML = D.legendas.map(function (x) { return '<li class="p3d__peca"><i></i><div><strong>' + x[1] + '</strong><span>' + x[2] + '</span></div></li>'; }).join('');
    var agora = raiz.querySelector('[data-p3d-agora]'), frase = raiz.querySelector('[data-p3d-frase]');
    var sobreTopo = raiz.querySelector('.p3d__topo') || frase, sobreBase = raiz.querySelector('.p3d__base');
    D.cores = D.cores.map(function (c) { c = c.length >= 5 ? c : [c[0], c[1], c[2], c[2], c[2]]; if (!c[5]) c[5] = c[3]; return c; });
    var soCores = (raiz.getAttribute('data-cores') || '').replace(/\s/g, '').split(',').filter(Boolean);
    if (soCores.length) { var fc = D.cores.filter(function (c) { return soCores.indexOf(c[0]) > -1; }); if (fc.length) D.cores = fc; }
    if (D.nav) { for (var nv = 0; nv < navs.length && nv < D.nav.length; nv++) navs[nv].textContent = D.nav[nv]; }
    var corAtual = raiz.getAttribute('data-cor') || D.cores[0][0];
    if (!D.cores.some(function (c) { return c[0] === corAtual; })) corAtual = D.cores[0][0];
    caixaCores.innerHTML = D.cores.map(function (c) {
      return '<button type="button" data-p3d-cor="' + c[0] + '" style="background:' + c[2] + '" aria-pressed="' + (c[0] === corAtual) + '" title="' + c[1] + '"><span class="sr-only visually-hidden" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">' + c[1] + '</span></button>';
    }).join('') + '<small data-p3d-cor-nome></small>';
    var corNome = caixaCores.querySelector('[data-p3d-cor-nome]');
    function hexDe(k) { for (var i = 0; i < D.cores.length; i++) if (D.cores[i][0] === k) return D.cores[i]; return D.cores[0]; }
    corNome.textContent = hexDe(corAtual)[1];

    var rend;
    try { rend = new THREE.WebGLRenderer({ antialias: true, alpha: true }); } catch (e) { semTresD(); return; }
    var TOQUE = window.matchMedia && matchMedia('(pointer: coarse)').matches;
    rend.setPixelRatio(Math.min(TOQUE ? 1.5 : 2, window.devicePixelRatio || 1));
    rend.shadowMap.enabled = true; rend.shadowMap.type = TOQUE ? THREE.PCFShadowMap : THREE.PCFSoftShadowMap;
    palco.insertBefore(rend.domElement, rots);
    var cena = new THREE.Scene();
    var cam = new THREE.PerspectiveCamera(26, 1, 50, 40000);
    cena.add(new THREE.HemisphereLight(0xffffff, 0xb7c0ca, 1.65));
    var sol = new THREE.DirectionalLight(0xffffff, 1.9); sol.position.set(1500, 2800, 2100); sol.castShadow = true;
    sol.shadow.mapSize.set(TOQUE ? 1024 : 2048, TOQUE ? 1024 : 2048);
    sol.shadow.camera.left = -1600; sol.shadow.camera.right = 1600; sol.shadow.camera.top = 1600; sol.shadow.camera.bottom = -1600;
    sol.shadow.camera.near = 100; sol.shadow.camera.far = 9000; sol.shadow.radius = 4; sol.shadow.bias = -0.0009; sol.shadow.normalBias = 1.5;
    cena.add(sol);
    var luz2 = new THREE.DirectionalLight(0xffffff, .55); luz2.position.set(-2000, 900, 1200); cena.add(luz2);
    var chao = new THREE.Mesh(new THREE.PlaneGeometry(9000, 9000), new THREE.ShadowMaterial({ opacity: .14 }));
    chao.rotation.x = -Math.PI / 2; chao.position.y = -1; chao.receiveShadow = true; cena.add(chao);

    var MATS = {
      mdf: new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: .74, metalness: 0, side: THREE.DoubleSide }),
      frt: new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: .74, metalness: 0, side: THREE.DoubleSide }),
      tmp: new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: .74, metalness: 0, side: THREE.DoubleSide }),
      det: new THREE.MeshStandardMaterial({ color: 0x8A8D90, roughness: .45, metalness: .2, side: THREE.DoubleSide }),
      vid: new THREE.MeshStandardMaterial({ color: 0xD4DEE6, roughness: .05, metalness: .35, side: THREE.DoubleSide }),
      acb: new THREE.MeshStandardMaterial({ color: 0xF4F4F4, roughness: .74, metalness: 0, side: THREE.DoubleSide }),
      tela: new THREE.MeshStandardMaterial({ color: 0x0B0D10, roughness: .18, metalness: .3, side: THREE.DoubleSide }),
      tvc: new THREE.MeshStandardMaterial({ color: 0x1D1E21, roughness: .5, metalness: .2, side: THREE.DoubleSide }),
      int: new THREE.MeshStandardMaterial({ color: 0xF1EFEC, roughness: .8, side: THREE.DoubleSide }),
      pia: new THREE.MeshStandardMaterial({ color: 0xF8F7F4, roughness: .3, side: THREE.DoubleSide }),
      mad: new THREE.MeshStandardMaterial({ color: 0xC59B6D, roughness: .62, side: THREE.DoubleSide }),
      met: new THREE.MeshStandardMaterial({ color: 0xC9CCD0, roughness: .28, metalness: .55, side: THREE.DoubleSide })
    };
    var linhaMat = new THREE.LineBasicMaterial({ color: 0x1c1c1c, transparent: true, opacity: .16 });
    var usaFreijo = D.cores.some(function (c) { return c[3] === 'freijo' || c[4] === 'freijo' || c[5] === 'freijo'; });
    var texFreijo = null, texPronta = Promise.resolve();
    if (usaFreijo && raiz.getAttribute('data-freijo')) {
      texPronta = new Promise(function (ok) {
        texFreijo = new THREE.TextureLoader().load(raiz.getAttribute('data-freijo'), function () { precisa = true; ok(); }, undefined, function () { ok(); });
      });
      texFreijo.wrapS = texFreijo.wrapT = THREE.RepeatWrapping;
      if ('SRGBColorSpace' in THREE) texFreijo.colorSpace = THREE.SRGBColorSpace;
    }
    function pinta(mat, v) {
      if (v === 'freijo' && texFreijo) { mat.map = texFreijo; mat.color.set(0xffffff); }
      else { mat.map = null; mat.color.set(v === 'freijo' ? '#99682E' : v); }
      mat.needsUpdate = true;
    }
    function aplicaCor(k) { var c = hexDe(k); pinta(MATS.mdf, c[3]); pinta(MATS.frt, c[4]); pinta(MATS.tmp, c[5]); precisa = true; }
    // coordenadas de textura em caixa: o veio corre na vertical nas peças em pé e na largura nas deitadas
    function uvCaixa(geo, emPe) {
      var p = geo.attributes.position, n = p.count, uv = new Float32Array(n * 2);
      var a = new THREE.Vector3(), b = new THREE.Vector3(), c = new THREE.Vector3(), nm = new THREE.Vector3();
      var tri = [], planos = {};
      for (var i = 0; i < n; i += 3) {
        a.fromBufferAttribute(p, i); b.fromBufferAttribute(p, i + 1); c.fromBufferAttribute(p, i + 2);
        nm.subVectors(c, b).cross(new THREE.Vector3().subVectors(a, b));
        var ax = Math.abs(nm.x), ay = Math.abs(nm.y), az = Math.abs(nm.z), eixo, d;
        if (ay >= ax && ay >= az) { eixo = 'y'; d = a.y; } else if (ax >= az) { eixo = 'x'; d = a.x; } else { eixo = 'z'; d = a.z; }
        // os dois eixos do plano da face
        var e1 = eixo === 'x' ? 'z' : 'x', e2 = eixo === 'y' ? 'z' : 'y';
        var k = eixo + Math.round(d) + (nm[eixo] > 0 ? '+' : '-');
        var pl = planos[k] || (planos[k] = { e1: e1, e2: e2, m1: Infinity, M1: -Infinity, m2: Infinity, M2: -Infinity });
        [a, b, c].forEach(function (q) { pl.m1 = Math.min(pl.m1, q[e1]); pl.M1 = Math.max(pl.M1, q[e1]); pl.m2 = Math.min(pl.m2, q[e2]); pl.M2 = Math.max(pl.M2, q[e2]); });
        tri.push(k);
      }
      for (var t = 0; t < tri.length; t++) {
        var pl = planos[tri[t]], veio = (pl.M1 - pl.m1) > (pl.M2 - pl.m2) ? pl.e1 : pl.e2;
        if (emPe && (pl.e1 === 'y' || pl.e2 === 'y')) veio = 'y';
        var cruz = veio === pl.e1 ? pl.e2 : pl.e1;
        for (var v = 0; v < 3; v++) {
          var i3 = t * 3 + v;
          a.fromBufferAttribute(p, i3);
          uv[i3 * 2] = a[cruz] / 600; uv[i3 * 2 + 1] = a[veio] / 1066;
        }
      }
      geo.setAttribute('uv', new THREE.BufferAttribute(uv, 2));
    }

    // contornos das peças: arestas onde a dobra passa de 40 graus. Triângulos finos
    // demais (pontes dos furos) ficam de fora, senão viram riscos sobre a chapa.
    function contornos(geo) {
      var p = geo.attributes.position.array, ix = geo.index ? geo.index.array : null, n = ix ? ix.length : p.length / 3;
      var mapa = {}, saida = [], lim = Math.cos(40 * Math.PI / 180);
      function k(i) { return Math.round(p[i * 3] * 10) + ',' + Math.round(p[i * 3 + 1] * 10) + ',' + Math.round(p[i * 3 + 2] * 10); }
      for (var t = 0; t < n; t += 3) {
        var a = ix ? ix[t] : t, b = ix ? ix[t + 1] : t + 1, c = ix ? ix[t + 2] : t + 2;
        var ux = p[b * 3] - p[a * 3], uy = p[b * 3 + 1] - p[a * 3 + 1], uz = p[b * 3 + 2] - p[a * 3 + 2];
        var vx = p[c * 3] - p[a * 3], vy = p[c * 3 + 1] - p[a * 3 + 1], vz = p[c * 3 + 2] - p[a * 3 + 2];
        var nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx, ar = Math.sqrt(nx * nx + ny * ny + nz * nz);
        var l1 = Math.hypot(ux, uy, uz), l2 = Math.hypot(vx, vy, vz), l3 = Math.hypot(p[c * 3] - p[b * 3], p[c * 3 + 1] - p[b * 3 + 1], p[c * 3 + 2] - p[b * 3 + 2]);
        if (!ar || ar / Math.max(l1, l2, l3) < .6) continue;
        nx /= ar; ny /= ar; nz /= ar;
        [[a, b], [b, c], [c, a]].forEach(function (e) {
          var ka = k(e[0]), kb = k(e[1]), ch = ka < kb ? ka + '|' + kb : kb + '|' + ka, r = mapa[ch];
          if (!r) mapa[ch] = { n: [nx, ny, nz], a: e[0], b: e[1], c: 1 };
          else { r.c++; r.d = r.n[0] * nx + r.n[1] * ny + r.n[2] * nz; }
        });
      }
      Object.keys(mapa).forEach(function (ch) {
        var r = mapa[ch];
        if (r.c === 2 && r.d < lim) saida.push(p[r.a * 3], p[r.a * 3 + 1], p[r.a * 3 + 2], p[r.b * 3], p[r.b * 3 + 1], p[r.b * 3 + 2]);
      });
      var g = new THREE.BufferGeometry(); g.setAttribute('position', new THREE.Float32BufferAttribute(saida, 3)); return g;
    }
    var G = {}, PORTAS = D.portas || {}, minZ = Infinity, VEIO_PE = /^(ac\d*_)?(lat|div|fundo_nicho|costa)/;
    Object.keys(D.grupos).forEach(function (n) {
      var g = new THREE.Group(), alvo = g, caixa = new THREE.Box3(), pt = PORTAS[n];
      if (pt) {
        // porta: gira em torno da dobradiça, na borda de fora da face da frente
        var piv = new THREE.Group(), dentro = new THREE.Group();
        if (pt.tipo === 'x') { piv.position.set(0, pt.eixo[0], pt.eixo[1]); dentro.position.set(0, -pt.eixo[0], -pt.eixo[1]); }
        else { piv.position.set(pt.eixo[0], 0, pt.eixo[1]); dentro.position.set(-pt.eixo[0], 0, -pt.eixo[1]); }
        piv.add(dentro); g.add(piv); g.userData.piv = piv; alvo = dentro;
      }
      D.grupos[n].forEach(function (h) {
        var pc = D.pecas[h]; if (!pc) return;
        var geo = new THREE.BufferGeometry();
        geo.setAttribute('position', new THREE.Float32BufferAttribute(pc.p, 3)); geo.setIndex(pc.i);
        var mk = D.mat[h] || 'mdf', mgeo = geo;
        if (usaFreijo && (mk === 'mdf' || mk === 'frt' || mk === 'tmp')) { mgeo = geo.toNonIndexed(); uvCaixa(mgeo, VEIO_PE.test(n) || (D.veioEmPe || []).indexOf(n) > -1); }
        if (pc.n && mgeo === geo) mgeo.setAttribute('normal', new THREE.Float32BufferAttribute(pc.n, 3));
        else mgeo.computeVertexNormals();
        var m = new THREE.Mesh(mgeo, MATS[mk]); m.castShadow = true; m.receiveShadow = mk !== 'pia' || pc.i.length < 3000; alvo.add(m);
        // malhas finas e curvas (cubas vindas do DWG) ficam sem os contornos, senão viram listras
        if (pc.i.length < 3000) alvo.add(new THREE.LineSegments(contornos(geo), linhaMat));
        geo.computeBoundingBox(); caixa.union(geo.boundingBox);
      });
      if (caixa.min.z < minZ) minZ = caixa.min.z;
      g.userData.caixa = caixa; G[n] = g; g.visible = !ESCONDE[n] && !(D.pesVendidos && /^pe_/.test(n)); cena.add(g);
    });
    var PISTOES = [], metal = MATS.met, baixaY = 0;
    function caixaLocal(n) { return G[n].userData.caixa; }
    function grupoPerto(x, y) {
      // a lateral ou divisória mais perto (para o que fica parado quando a gaveta abre)
      var melhor = null, dm = Infinity;
      Object.keys(G).forEach(function (n) {
        if (!/^(ac\d*_)?(lat|div)/.test(n)) return;
        var c = caixaLocal(n); if (y < c.min.y - 5 || y > c.max.y + 5) return;
        var d = Math.min(Math.abs(c.min.x - x), Math.abs(c.max.x - x)); if (d < dm) { dm = d; melhor = n; }
      });
      return melhor ? G[melhor] : cena;
    }
    function caixaM(sx, sy, sz, x, y, z, alvo) {
      var m = new THREE.Mesh(new THREE.BoxGeometry(sx, sy, sz), metal); m.position.set(x, y, z); m.castShadow = false; alvo.add(m); return m;
    }
    function copo(x, y, z, alvo) {
      var g = new THREE.CylinderGeometry(17.5, 17.5, 11, 22); g.rotateX(Math.PI / 2);
      var m = new THREE.Mesh(g, metal); m.position.set(x, y, z); alvo.add(m); return m;
    }
    Object.keys(PORTAS).forEach(function (n) {
      var pt = PORTAS[n], g = G[n]; if (!g || !g.userData.piv) return;
      var dentro = g.userData.piv.children[0], c = caixaLocal(n), zi = c.min.z - 6;
      var qt = pt.dobr || D.dobradicas || 2, w = c.max.x - c.min.x, h = c.max.y - c.min.y;
      if (pt.tipo === 'x') {
        // basculante: dobradiças na borda de baixo e um pistão que segura a porta
        var xs = qt === 3 ? [c.min.x + w * .15, (c.min.x + c.max.x) / 2, c.max.x - w * .15] : [c.min.x + Math.min(90, w * .2), c.max.x - Math.min(90, w * .2)];
        xs.forEach(function (x) { copo(x, c.min.y + 26, zi, dentro); caixaM(46, 10, 22, x, c.min.y + 12, zi - 12, dentro); });
        var px = c.min.x + Math.min(45, w * .12);
        var A = new THREE.Vector3(px, c.min.y + h * .92, zi - 70), B = new THREE.Vector3(px, c.min.y + h * .3, zi + 2);
        var pis = new THREE.Group(), corpo = new THREE.CylinderGeometry(8, 8, 1, 14), haste = new THREE.CylinderGeometry(3.5, 3.5, 1, 10);
        corpo.translate(0, .5, 0); haste.translate(0, .5, 0);
        var mc = new THREE.Mesh(corpo, metal), mh = new THREE.Mesh(haste, metal); mc.scale.y = .55; mh.position.y = .5; mh.scale.y = .5;
        pis.add(mc); pis.add(mh); cena.add(pis);
        PISTOES.push({ n: n, A: A, B: B, obj: pis, piv: pt });
      } else {
        // porta de abrir: dobradiças de caneco na borda da dobradiça (3 nos armários com espelho)
        var xb = Math.abs(pt.eixo[0] - c.min.x) < Math.abs(pt.eixo[0] - c.max.x) ? c.min.x + 26 : c.max.x - 26;
        var ys = qt === 3 ? [c.max.y - 90, (c.min.y + c.max.y) / 2, c.min.y + 90] : [c.max.y - Math.min(100, h * .2), c.min.y + Math.min(100, h * .2)];
        ys.forEach(function (y) { copo(xb, y, zi, dentro); caixaM(14, 46, 10, xb + (xb < (c.min.x + c.max.x) / 2 ? -14 : 14), y, zi - 9, dentro); });
      }
    });
    Object.keys(D.gaveta || {}).forEach(function (n) {
      // corrediças telescópicas nas laterais da caixa: o trilho de dentro vai com a gaveta
      if (!/^(ac\d*_)?gav/.test(n) || !G[n]) return;
      var c = caixaLocal(n), prof = (c.max.z - c.min.z) * .96, zc = (c.min.z + c.max.z) / 2, y = c.min.y + Math.min(40, (c.max.y - c.min.y) * .35);
      [[c.min.x - 4, c.min.x - 10], [c.max.x + 4, c.max.x + 10]].forEach(function (par) {
        caixaM(5, 34, prof, par[0], y, zc, G[n]);
        caixaM(5, 40, prof, par[1], y, zc, grupoPerto(par[1], y));
      });
    });
    var _v = new THREE.Vector3(), _d = new THREE.Vector3(), _Y = new THREE.Vector3(0, 1, 0);
    function pistoes(st) {
      PISTOES.forEach(function (o) {
        var g = G[o.n], vis = g.visible && st.ex < .03; o.obj.visible = vis; if (!vis) return;
        // B acompanha a porta: gira em torno da dobradiça de baixo
        var th = g.userData.piv.rotation.x, py = o.piv.eixo[0], pz = o.piv.eixo[1];
        var y = o.B.y - py, z = o.B.z - pz;
        _v.set(o.B.x, py + y * Math.cos(th) - z * Math.sin(th), pz + y * Math.sin(th) + z * Math.cos(th)).add(g.position);
        _d.subVectors(_v, o.A); var L = _d.length();
        o.obj.position.copy(o.A); if (!/^ac\d*_/.test(o.n)) o.obj.position.y -= baixaY;
        _d.subVectors(_v, o.obj.position); L = _d.length();
        o.obj.quaternion.setFromUnitVectors(_Y, _d.normalize()); o.obj.scale.set(1, L, 1);
      });
    }
    aplicaCor(corAtual);
    if (D.suspenso) {
      // gabinete suspenso: uma parede atrás recebe a sombra, para ele não parecer solto no ar
      var parede = new THREE.Mesh(new THREE.PlaneGeometry(9000, 9000), new THREE.ShadowMaterial({ opacity: .1 }));
      parede.position.set(0, 0, minZ - 2); parede.receiveShadow = true; cena.add(parede);
    }

    var fatorEx = 1;
    function suave(a, b, x) { var t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); }
    var NP = Math.max(1, (D.passos || []).length);
    var cur = { g: [0], ex: 0, ga: 0 }, alvo = { g: [0], ex: 0 };
    for (var k0 = 1; k0 <= Math.max(3, NP); k0++) { cur.g.push(0); alvo.g.push(0); }
    var tAnt = 0, VEL = 5;
    // o móvel nasce aberto: ao chegar no bloco, gavetas e portas fecham devagar
    var abreNaChegada = !REDUZ && (Object.keys(D.gaveta || {}).length > 0 || Object.keys(D.portas || {}).length > 0);
    if (abreNaChegada) { for (var k1 = 1; k1 <= NP; k1++) { cur.g[k1] = 1; alvo.g[k1] = 1; } cur.ga = 1; }
    function avanca() {
      var t = performance.now(), dt = tAnt ? Math.min(.05, (t - tAnt) / 1000) : .016; tAnt = t;
      var k = REDUZ ? 1 : 1 - Math.exp(-dt * VEL), mexeu = false;
      for (var i = 1; i < cur.g.length; i++) {
        var d = alvo.g[i] - cur.g[i];
        if (Math.abs(d) > .002) { cur.g[i] += d * k; mexeu = true; } else cur.g[i] = alvo.g[i];
      }
      var dx = alvo.ex - cur.ex; if (Math.abs(dx) > .002) { cur.ex += dx * k * .8; mexeu = true; } else cur.ex = alvo.ex;
      var gaA = Math.max.apply(null, alvo.g) > 0 ? 1 : 0, dg = gaA - cur.ga;
      if (Math.abs(dg) > .002) { cur.ga += dg * k * .7; mexeu = true; } else cur.ga = gaA;
      return mexeu;
    }
    function estado() { return { g: cur.g, ex: cur.ex, ga: cur.ga }; }
    function aplica(st) {
      Object.keys(G).forEach(function (n) {
        var o = D.explode[n] || [0, 0, 0], gv = D.gaveta && D.gaveta[n], z = gv ? gv[1] * st.g[gv[0]] : 0, k = st.ex * fatorEx;
        // v195: o móvel desce até os pés vendidos à parte; os pés e as peças de cima ficam onde estão
        G[n].position.set(o[0] * k, o[1] * k - (/^ac\d*_/.test(n) || /^pe_/.test(n) ? 0 : baixaY), o[2] * k + z);
        var pt = PORTAS[n];
        if (pt && G[n].userData.piv) {
          var ang = pt.ang * Math.PI / 180 * st.g[pt.passo];
          if (pt.tipo === 'x') G[n].userData.piv.rotation.x = ang; else G[n].userData.piv.rotation.y = ang;
        }
      });
      pistoes(st);
    }
    var dist = 0, centro = new THREE.Vector3(0, 450, 0), alvoC = new THREE.Vector3(), cx = new THREE.Box3(), tmp = new THREE.Vector3(), esfera = new THREE.Sphere();
    function caixaDe(n, alvo) {
      var g = G[n];
      if (g.userData.piv) { g.updateMatrixWorld(true); return alvo.setFromObject(g); }
      alvo.copy(g.userData.caixa);
      var tv = g.userData.tv;
      if (tv && tv.esc !== 1) {
        alvo.min.x = tv.ax + (alvo.min.x - tv.ax) * tv.esc; alvo.max.x = tv.ax + (alvo.max.x - tv.ax) * tv.esc;
        alvo.min.y = tv.ay + (alvo.min.y - tv.ay) * tv.esc; alvo.max.y = tv.ay + (alvo.max.y - tv.ay) * tv.esc;
      }
      return alvo.translate(g.position);
    }
    // v182: a coluna do texto e dos controles, medida a partir do canto do palco quando
    // ele muda de tamanho. colTexto: até onde vai tudo; colLado: até onde vai o que fica
    // ao lado do móvel abaixo do nome (diferenciais, aviso de toque, cores e botões);
    // fimNome: onde termina o nome
    var colTexto = -1, colLado = 0, fimNome = 0, faixa = document.createRange(), focoCaixa = null;
    function medeColuna() {
      var pr = palco.getBoundingClientRect(); colTexto = 0; colLado = 0; fimNome = 0;
      Array.prototype.forEach.call(raiz.querySelectorAll('.p3d__frase, .p3d__selos li, .p3d__topo .p3d__dica, .p3d__cores > *, .p3d__alterna, .p3d__ar'), function (el) {
        var r, nome = el.classList.contains('p3d__frase');
        if (el.classList.contains('p3d__frase')) { faixa.selectNodeContents(el); r = faixa.getBoundingClientRect(); } else r = el.getBoundingClientRect();
        if (!(r.width > 0)) return;
        colTexto = Math.max(colTexto, r.right - pr.left);
        if (nome) fimNome = Math.max(fimNome, r.bottom - pr.top); else colLado = Math.max(colLado, r.right - pr.left);
      });
    }
    function enquadra(imediato, neutro) {
      var bb = new THREE.Box3();
      Object.keys(G).forEach(function (n) { if (!G[n].visible) return; caixaDe(n, cx); bb.union(cx); });
      if (focoCaixa && !neutro) bb.copy(focoCaixa);   // v191: encanamento
      bb.getCenter(alvoC); bb.getBoundingSphere(esfera);
      var H = palco.clientHeight || 1, W = palco.clientWidth || 1, pr = palco.getBoundingClientRect();
      var cima = sobreTopo ? sobreTopo.getBoundingClientRect().bottom - pr.top + 8 : 0;
      var baixo = sobreBase ? pr.bottom - sobreBase.getBoundingClientRect().top + 8 : 0;
      // no computador os controles de baixo ficam na esquerda: se não chegam perto do meio,
      // o móvel desce até perto da borda
      if (W >= 1000 && sobreBase) {
        var rb = sobreBase.getBoundingClientRect();
        if (rb.top - pr.top < H * .5) { cima = Math.max(cima, rb.bottom - pr.top + 8); baixo = 76; }   // v184: cores e Abrir em cima
        else {
          var dir = 0; Array.prototype.forEach.call(sobreBase.children, function (el) { if (!el.classList.contains('p3d__seguir') && !el.classList.contains('p3d__dica') && !el.classList.contains('p3d__aviso')) dir = Math.max(dir, el.getBoundingClientRect().right - pr.left); });
          if (dir < W * .3) baixo = 56;
        }
      }
      cima = Math.max(0, Math.min(cima, H * .6)); baixo = Math.max(0, Math.min(baixo, H * .4));
      var vf = cam.fov * Math.PI / 180, hf = 2 * Math.atan(Math.tan(vf / 2) * cam.aspect);
      // v182: maneiras de enquadrar, e vale a que deixa o móvel maior.
      // 1) em faixa: entre o texto de cima e os controles de baixo, na largura toda;
      // no computador, com a seta livre embaixo e sem passar por baixo do texto da
      // esquerda (nem do espelho dele à direita):
      // 2) na altura toda, no meio, ao lado de todo o texto;
      // 3) logo abaixo do nome e dos diferenciais, ao lado do aviso e dos botões.
      var ops = [{ c: cima, b: baixo, tH: Math.tan(hf * .92 / 2) }];
      if (W >= 1000) {
        if (colTexto < 0) medeColuna();
        var larg = (W - 2 * (colTexto + 28)) / W, larg2 = (W - 2 * (colLado + 28)) / W;
        if (larg > .25) ops.push({ c: 28, b: 76, tH: Math.tan(hf / 2) * larg });
        if (larg2 > .25 && fimNome > 0) ops.push({ c: fimNome + 14, b: 76, tH: Math.tan(hf / 2) * larg2 });
      }
      var melhor = null;
      if (!neutro) {
        var ca = Math.cos(ultAz), sa = Math.sin(ultAz), ce = Math.cos(ultEl), se = Math.sin(ultEl);
        var fx = -sa * ce, fy = -se, fz = -ca * ce;            // para onde a câmera olha
        var rx = ca, ry = 0, rz = -sa;                         // direita
        var ux = ry * fz - rz * fy, uy = rz * fx - rx * fz, uz = rx * fy - ry * fx;   // cima
      }
      ops.forEach(function (o, io) {
        var livre = Math.max(H * .35, H - o.c - o.b);
        var vfl = 2 * Math.atan(Math.tan(vf / 2) * livre / H), tV = Math.tan(vfl / 2);
        var d = esfera.radius / Math.sin(Math.min(vfl, 2 * Math.atan(o.tH)) / 2) * 1.02, desl = (o.c - o.b) / 2;
        if (!neutro) {
          var dmin = 0, cs = [];
          for (var ci = 0; ci < 8; ci++) {
            var px = (ci & 1 ? bb.max.x : bb.min.x) - alvoC.x, py = (ci & 2 ? bb.max.y : bb.min.y) - alvoC.y, pz = (ci & 4 ? bb.max.z : bb.min.z) - alvoC.z;
            var xr = px * rx + py * ry + pz * rz, yu = px * ux + py * uy + pz * uz, zf = px * fx + py * fy + pz * fz;
            cs.push([Math.abs(xr), yu, zf]);
            dmin = Math.max(dmin, zf + Math.abs(xr) / o.tH, zf + Math.abs(yu) / tV);
          }
          if (dmin > 0) d = dmin * 1.04;
          if (io > 0) {
            // v182, na altura toda: a conta exata da perspectiva. Acha a menor distância em que
            // o móvel cabe na faixa (de cima a baixo) e na coluna do meio, e centra o que
            // aparece dele na faixa (a torneira em cima não deixa sobra embaixo)
            var t2 = Math.tan(vf / 2), meia = (H - o.c - o.b) / H * t2;
            var proj = function (dd) {
              var y0 = Infinity, y1 = -Infinity, x1 = 0;
              for (var k = 0; k < 8; k++) {
                var z = dd + cs[k][2]; if (z <= 1) return null;
                var y = cs[k][1] / z; if (y < y0) y0 = y; if (y > y1) y1 = y; x1 = Math.max(x1, cs[k][0] / z);
              }
              return [y0, y1, x1];
            };
            var cabe = function (dd) { var r = proj(dd); return r && (r[1] - r[0]) / 2 <= meia && r[2] <= o.tH; };
            var lo = esfera.radius * .3, hi = Math.max(d, esfera.radius * 3);
            if (cabe(hi)) {
              for (var it = 0; it < 28; it++) { var md = (lo + hi) / 2; if (cabe(md)) hi = md; else lo = md; }
              d = hi * 1.03;
              var r = proj(d); if (r) desl = (o.c - o.b) / 2 + (r[0] + r[1]) / 2 * (H / 2) / t2;
            }
          }
        }
        if (!melhor || d < melhor.d) melhor = { d: d, desl: desl };
      });
      var alvoD = melhor.d, desl = melhor.desl;
      // v208: com porta ou gaveta aberta, a câmera chega mais perto do que abriu (dá para ver os detalhes)
      if (!neutro && !focoCaixa && alvo.g.some(function (v) { return v > 0; })) {
        var ab = new THREE.Box3(), tb = new THREE.Box3();
        Object.keys(G).forEach(function (n) {
          var s = (D.gaveta && D.gaveta[n]) ? D.gaveta[n][0] : ((D.portas && D.portas[n]) ? (D.portas[n].passo || 1) : 0);
          if (s && alvo.g[s] > 0 && G[n].visible) { caixaDe(n, tb); ab.union(tb); }
        });
        if (!ab.isEmpty()) { var ca = ab.getCenter(new THREE.Vector3()); alvoC.lerp(ca, .55); alvoD *= .74; desl *= .6; }
      }
      if (neutro) { desl = 0; alvoD = esfera.radius / Math.sin(Math.min(vf, hf) / 2) * 1.02; }
      var dRef = dist || alvoD; cam.near = Math.max(10, dRef - esfera.radius * 2.2); cam.far = dRef + esfera.radius * 4 + 2000;
      cam.setViewOffset(W, H, 0, -desl, W, H);
      if (imediato || !dist) { dist = alvoD; centro.copy(alvoC); return false; }
      dist += (alvoD - dist) * .12; centro.lerp(alvoC, .12);
      return Math.abs(alvoD - dist) > 1;
    }
    // o que cada passo mostra de ferragem, pelo tipo do que abre nele
    var FERRAGEM = {};
    for (var q0 = 1; q0 <= NP; q0++) {
      var ehGav = Object.keys(D.gaveta || {}).some(function (n) { return /^(ac\d*_)?gav/.test(n) && D.gaveta[n][0] === q0; });
      var basc = Object.keys(PORTAS).some(function (n) { return PORTAS[n].passo === q0 && PORTAS[n].tipo === 'x'; });
      var porta = Object.keys(PORTAS).some(function (n) { return PORTAS[n].passo === q0 && PORTAS[n].tipo !== 'x'; });
      FERRAGEM[q0] = D.avisoAcao && q0 === 1 ? D.avisoAcao : (ehGav ? 'Corrediças telescópicas' : (basc ? 'Pistão na porta basculante' : (porta ? 'Dobradiças com amortecedor' : '')));
    }
    var temGav = Object.keys(D.gaveta || {}).length > 0, temPorta = Object.keys(PORTAS).length > 0;
    var acao = temGav || temPorta;
    var toque = raiz.querySelector('[data-p3d-toque]'), aviso = raiz.querySelector('[data-p3d-aviso]'), avisoT = 0;
    var verbo = TOQUE ? 'Toque' : 'Clique';
    if (toque) toque.textContent = (temGav && temPorta) ? verbo + ' nas portas e gavetas para abrir e fechar' : (temGav ? verbo + ' nas gavetas para abrir e fechar' : (temPorta ? verbo + ' nas portas para abrir e fechar' : 'Arraste para girar'));
    function avisa(t) {
      if (!aviso || !t) return;
      aviso.textContent = t; aviso.classList.add('on'); clearTimeout(avisoT);
      avisoT = setTimeout(function () { aviso.classList.remove('on'); }, 2400);
    }
    var alterna = raiz.querySelector('[data-p3d-alterna]');
    function marcaModo() {
      var aberto = alvo.g.some(function (v) { return v > 0; });
      if (alterna) {
        var rot = D.rotulos || ['Ver por trás', 'Ver de frente'];
        var ta = D.textosAcao || ['Abrir', 'Fechar'];
        var t = acao ? (aberto ? ta[1] : ta[0]) : (aberto ? rot[1] : rot[0]);
        if (alterna.textContent !== t) alterna.textContent = t;
        alterna.classList.toggle('aberto', aberto);
      }
      for (var i = 0; i < navs.length; i++) navs[i].classList.toggle('on', acao ? i !== (aberto ? 1 : 0) : i === (aberto ? 1 : 0));
    }
    function texto() {}
    function legendas() {}
    // no celular a barra de cima (título da seção) e a de compra ficam por cima do palco
    function folgas() {
      var topo = 0, base = 0;
      var cab = raiz.closest('.acc') && raiz.closest('.acc').querySelector('.acc__h');
      if (cab && getComputedStyle(cab).position === 'sticky') topo = cab.offsetHeight;
      var dock = document.querySelector('.dock');
      if (dock && getComputedStyle(dock).display !== 'none') base = dock.offsetHeight;
      raiz.style.setProperty('--p3d-topo', topo + 'px'); raiz.style.setProperty('--p3d-base', base + 'px');
      var vis = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      raiz.style.setProperty('--p3d-vis', Math.round(vis) + 'px');
    }
    function tamanho() {
      folgas(); colTexto = -1;
      var w = palco.clientWidth, h = palco.clientHeight; if (!w || !h) return;
      fatorEx = w < 700 ? .72 : 1;
      rend.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix(); precisa = true;
    }
    var p = 0, alvoP = 0, giro = 0, giroAlvo = 0, giroV = 0, precisa = true, vivo = false, primeiro = true, ultAz = .42, ultEl = .24;
    // ao chegar no bloco o móvel dá uma volta curta, para mostrar que é 3D (uma vez só, e para se a pessoa tocar)
    var tocou = false, apT0 = 0, APD = 2600;
    /* v203: enquanto a pessoa rola a página pelo bloco, o móvel gira de leve (uns 14 graus
       para cada lado ao longo da passagem). Quando ela toca no móvel, o giro da rolagem
       para onde estava, para não brigar com a mão dela. */
    var rolaG = 0, rolaCong = null;
    function giroRolagem() {
      if (REDUZ) return 0;
      if (tocou) { if (rolaCong === null) rolaCong = rolaG; return rolaCong; }
      rolaCong = null;
      var r = raiz.getBoundingClientRect(), vh = window.innerHeight || 800;
      var t = (vh - r.top) / (vh + r.height); t = t < 0 ? 0 : (t > 1 ? 1 : t);
      rolaG = (t - .5) * 28; return rolaG;
    }
    function apres() {
      if (tocou || REDUZ || !apT0) return 0;
      var t = (performance.now() - apT0) / APD;
      if (t < 0) { precisa = true; return 0; }
      if (t >= 1) { apT0 = 0; return 0; }
      precisa = true;
      return Math.sin(t * Math.PI * 2) * 32 * (1 - t);
    }
    /* v189: em rack e painel, a TV mostra o tamanho e a pessoa troca por outro
       (toque na TV ou na etiqueta) para ver como fica. A TV cresce a partir da
       base quando fica em pé no rack, e a partir do centro quando fica no painel. */
    var TVS = Object.keys(G).filter(function (n) { return n === 'tv' || /_tv$/.test(n); });
    var POL = [32, 43, 50, 55, 65, 75], tvEl = null, tvsEl = null, tvPol = 0, tvBase = 0;
    TVS.forEach(function (n) {
      var g = G[n], c = g.userData.caixa, tela = null;
      g.traverse(function (o) { if (o.isMesh && o.material === MATS.tela) { o.geometry.computeBoundingBox(); tela = tela ? tela.union(o.geometry.boundingBox) : o.geometry.boundingBox.clone(); } });
      var t = tela || c, w = t.max.x - t.min.x, h = t.max.y - t.min.y;
      if (!tvBase) tvBase = Math.sqrt(w * w + h * h) / 25.4;
      // os filhos vão para um grupo de dentro, que é o que cresce; o de fora continua com a posição de sempre
      var dentro = new THREE.Group(); while (g.children.length) dentro.add(g.children[0]); g.add(dentro);
      var emPe = (D.tvApoio || (/^ac\d*_/.test(n) ? 'centro' : 'base')) === 'base';
      g.userData.tv = { dentro: dentro, esc: 1, alvo: 1, ax: (c.min.x + c.max.x) / 2, ay: emPe ? c.min.y : (c.min.y + c.max.y) / 2 };
    });
    if (TVS.length && tvBase) {
      var maisPerto = function (v) { var m = POL[0]; POL.forEach(function (p) { if (Math.abs(p - v) < Math.abs(m - v)) m = p; }); return m; };
      tvPol = maisPerto(tvBase);
      tvEl = document.createElement('button'); tvEl.type = 'button'; tvEl.className = 'p3d__tv';
      tvEl.setAttribute('aria-haspopup', 'true'); tvEl.setAttribute('aria-expanded', 'false');
      tvsEl = document.createElement('div'); tvsEl.className = 'p3d__tvs'; tvsEl.hidden = true;
      tvsEl.innerHTML = '<span class="p3d__tvs-t">Tamanho da TV</span><span class="p3d__tvs-l">' +
        POL.map(function (p) { return '<button type="button" data-pol="' + p + '"' + (D.tvMax && p > D.tvMax ? ' class="p3d__tvs-mais"' : '') + '>' + p + '″</button>'; }).join('') + '</span>' +
        (D.tvMax ? '<span class="p3d__tvs-n">Indicado até ' + D.tvMax + '″ para este móvel</span>' : '');
      palco.appendChild(tvEl); palco.appendChild(tvsEl);
      // o toque na etiqueta e na lista não vira giro do móvel
      [tvEl, tvsEl].forEach(function (el) { ['pointerdown', 'pointerup', 'pointermove'].forEach(function (ev) { liga(el, ev, function (e) { e.stopPropagation(); }); }); });
      var marcaTV = function () {
        tvEl.innerHTML = 'TV ' + tvPol + '″<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 10 5 5 5-5"/></svg>';
        tvEl.setAttribute('aria-label', 'TV de ' + tvPol + ' polegadas. Trocar o tamanho');
        Array.prototype.forEach.call(tvsEl.querySelectorAll('[data-pol]'), function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-pol') === tvPol ? 'true' : 'false'); });
      };
      var abreTV = function (abre) { tvsEl.hidden = !abre; tvEl.setAttribute('aria-expanded', abre ? 'true' : 'false'); precisa = true; };
      raiz.__abreTV = abreTV;
      liga(tvEl, 'click', function (e) { e.stopPropagation(); usou(); abreTV(tvsEl.hidden); });
      liga(tvsEl, 'click', function (e) {
        e.stopPropagation();
        var b = e.target.closest('[data-pol]'); if (!b) return;
        tvPol = +b.getAttribute('data-pol'); marcaTV(); abreTV(false);
        TVS.forEach(function (n) { G[n].userData.tv.alvo = tvPol / tvBase; });
        precisa = true;
      });
      liga(document, 'click', function (e) { if (!tvsEl.hidden && !raiz.contains(e.target)) abreTV(false); });
      marcaTV();
    }
    var _pt = new THREE.Vector3(), _bt = new THREE.Box3();
    function tvAnda() {
      var mexeu = false;
      TVS.forEach(function (n) {
        var tv = G[n].userData.tv, d = tv.alvo - tv.esc;
        if (Math.abs(d) < .002) { if (tv.esc !== tv.alvo) { tv.esc = tv.alvo; mexeu = true; } }
        else { tv.esc += d * .22; mexeu = true; }
        if (mexeu) { tv.dentro.scale.set(tv.esc, tv.esc, 1); tv.dentro.position.set(tv.ax * (1 - tv.esc), tv.ay * (1 - tv.esc), 0); }
      });
      return mexeu;
    }
    function posTV() {
      if (!tvEl) return;
      var n = TVS[0], g = G[n];
      if (!g || !g.visible) { tvEl.hidden = true; tvsEl.hidden = true; return; }
      tvEl.hidden = false;
      caixaDe(n, _bt); _bt.getCenter(_pt); _pt.z = _bt.max.z + 4; _pt.project(cam);
      var W = palco.clientWidth, H = palco.clientHeight;
      var x = (_pt.x + 1) / 2 * W, y = (1 - _pt.y) / 2 * H;
      tvEl.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) translate(-50%,-50%)';
      if (!tvsEl.hidden) {
        var lw = tvsEl.offsetWidth || 260, lx = Math.max(8 + lw / 2, Math.min(W - 8 - lw / 2, x));
        tvsEl.style.transform = 'translate(' + lx.toFixed(1) + 'px,' + (y + 24).toFixed(1) + 'px) translateX(-50%)';
      }
    }
    function quadro() {
      if (!vivo || morto) return;
      requestAnimationFrame(quadro);
      var mudou = precisa || (apT0 && !tocou); precisa = false;
      if (avanca()) mudou = true;
      giro += (giroAlvo - giro) * .3; if (Math.abs(giroAlvo - giro) > .01) mudou = true; else giro = giroAlvo;
      var st = estado(); aplica(st);
      if (tvAnda()) mudou = true;
      if (enquadra(primeiro)) mudou = true;
      if (!mudou && !primeiro) return;
      var elg = Math.max(3, Math.min(62, 14 + (18 + (D.elevaFase1 || 0)) * st.ga + 8 * st.ex + giroV));
      var az = (24 + 12 * st.ga + (D.girarFase1 || 0) * st.ga + 16 * st.ex + giro + apres() + giroRolagem()) * Math.PI / 180, el = elg * Math.PI / 180;
      ultAz = az; ultEl = el;
      cam.position.set(centro.x + Math.sin(az) * Math.cos(el) * dist, centro.y + Math.sin(el) * dist, centro.z + Math.cos(az) * Math.cos(el) * dist);
      cam.lookAt(centro);
      rend.render(cena, cam);
      posAlvo(); posTV(); posCotas();
      legendas(st);
      if (primeiro) { primeiro = false; if (img) img.style.opacity = 0; raiz.classList.add('p3d--vivo'); }
    }
    liga(document, 'click', function (e) {
      if (e.target.closest && e.target.closest('.acc__t')) setTimeout(function () { tamanho(); }, 380);
    });
    liga(window, 'resize', function () { tamanho(); });
    liga(window, 'scroll', function () { if (vivo && !tocou && !REDUZ) precisa = true; }, { passive: true });
    if (window.visualViewport) liga(window.visualViewport, 'resize', function () { folgas(); precisa = true; });
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(function () { tamanho(); }); ro.observe(palco); OBS.push(ro); }
    // girar arrastando para o lado: o móvel vai para onde o dedo vai, sem atraso,
    // e continua um pouco ao soltar. A rolagem vertical segue normal (touch-action: pan-y)
    var x0 = null, y0 = 0, g0 = 0, v0 = 0, ultX = 0, ultT = 0, vel = 0, arrastando = false, inercia = 0;
    var SENS = TOQUE ? .55 : .4, LIM = 160;
    // o ângulo total fica entre 62 graus para cada lado da frente
    function limGiro(g) { var base = 24 + 12 * cur.ga; return Math.max(-62 - base, Math.min(62 - base, g)); }
    var px0 = 0, py0 = 0, pt0 = 0, moveu = 0;
    liga(palco, 'pointerdown', function (e) {
      x0 = e.clientX; y0 = e.clientY; g0 = giroAlvo; v0 = giroV; ultX = e.clientX; ultT = performance.now(); vel = 0; arrastando = true;
      px0 = e.clientX; py0 = e.clientY; pt0 = performance.now(); moveu = 0; tocou = true;
      para(); cancelAnimationFrame(inercia); palco.classList.add('arrasta'); ativa();
    });
    liga(window, 'pointermove', function (e) {
      if (x0 === null) return;
      var agoraT = performance.now(), dt = Math.max(1, agoraT - ultT);
      vel = (e.clientX - ultX) / dt; ultX = e.clientX; ultT = agoraT;
      giroAlvo = limGiro(g0 - (e.clientX - x0) * SENS); giro = giroAlvo;
      // para cima e para baixo: o bastante para ver por dentro, sem tombar o móvel
      giroV = Math.max(-12, Math.min(40, v0 + (e.clientY - y0) * SENS * .6)); precisa = true;
      moveu = Math.max(moveu, Math.abs(e.clientX - px0) + Math.abs(e.clientY - py0));
      // a pessoa quis rolar a página (arrasto vertical): o próximo gesto já rola, e o botão de sair acende
      var ddy = Math.abs(e.clientY - py0), ddx = Math.abs(e.clientX - px0);
      if (ativo && ddy > 70 && ddy > ddx * 1.6) {
        ativo = false; clearTimeout(ativoT); palco.style.touchAction = '';
        raiz.classList.add('p3d--sair'); setTimeout(function () { raiz.classList.remove('p3d--sair'); }, 2200);
      }
      if (moveu > 8 && dica) dica.classList.add('some');
    });
    var ativo = false, ativoT = 0;
    function ativa() { ativo = true; clearTimeout(ativoT); palco.style.touchAction = 'none'; usou(); }
    function libera() { clearTimeout(ativoT); ativoT = setTimeout(function () { ativo = false; palco.style.touchAction = ''; }, 2600); }
    function solta() {
      if (x0 === null) return;
      libera();
      x0 = null; arrastando = false; palco.classList.remove('arrasta');
      var v = -vel * SENS * 16;
      (function passo() {
        if (Math.abs(v) < .05) return;
        giroAlvo = limGiro(giroAlvo + v); giro = giroAlvo; v *= .92; precisa = true;
        inercia = requestAnimationFrame(passo);
      })();
    }
    ['pointerup', 'pointercancel'].forEach(function (n) { liga(window, n, solta); });
    var ray = new THREE.Raycaster(), ndc = new THREE.Vector2(), MALHAS = [];
    Object.keys(G).forEach(function (n) { G[n].userData.nome = n; G[n].traverse(function (o) { if (o.isMesh) MALHAS.push(o); }); });
    function passoDe(n) {
      if (PORTAS[n]) return PORTAS[n].passo;
      if (D.gaveta && D.gaveta[n]) return D.gaveta[n][0];
      return 0;
    }
    // v186: com o mouse, a mão de clicar aparece só em cima do que abre (porta, gaveta);
    // no resto do móvel fica a mão de arrastar. Uma conta por quadro, no máximo.
    var mira = 0;
    liga(palco, 'pointermove', function (e) {
      if (e.pointerType !== 'mouse' || x0 !== null || mira) return;
      mira = requestAnimationFrame(function () {
        mira = 0;
        var r = rend.domElement.getBoundingClientRect();
        ndc.set((e.clientX - r.left) / r.width * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
        ray.setFromCamera(ndc, cam);
        var hits = ray.intersectObjects(MALHAS.filter(function (m) { var o = m; while (o && !o.userData.nome) o = o.parent; return o && o.visible; }), false), abre = false;
        for (var i = 0; i < hits.length && !abre; i++) { var o = hits[i].object; while (o && !o.userData.nome) o = o.parent; if (o && (passoDe(o.userData.nome) || (i === 0 && o.userData.tv))) abre = true; }
        palco.classList.toggle('p3d__palco--abre', abre);
      });
    });
    liga(palco, 'pointerleave', function () { palco.classList.remove('p3d__palco--abre'); });
    liga(palco, 'pointerup', function (e) {
      if (moveu > 8 || performance.now() - pt0 > 450) return;
      var r = rend.domElement.getBoundingClientRect();
      ndc.set((e.clientX - r.left) / r.width * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
      ray.setFromCamera(ndc, cam);
      var hits = ray.intersectObjects(MALHAS.filter(function (m) { var o = m; while (o && !o.userData.nome) o = o.parent; return o && o.visible; }), false);
      if (raiz.__abreTV) {
        var o0 = hits.length ? hits[0].object : null; while (o0 && !o0.userData.nome) o0 = o0.parent;
        if (o0 && o0.userData.tv) { usou(); raiz.__abreTV(true); return; }
        raiz.__abreTV(false);
      }
      for (var i = 0; i < hits.length; i++) {
        var o = hits[i].object; while (o && !o.userData.nome) o = o.parent;
        var s = o ? passoDe(o.userData.nome) : 0;
        if (s) {
          if (alvo.ex > 0) { alvo.ex = 0; }
          VEL = 5; alvo.g[s] = alvo.g[s] > .5 ? 0 : 1; marcaModo(); precisa = true; usou();
          if (alvo.g[s]) avisa(FERRAGEM[s]);
          return;
        }
      }
    });
    function modo(m) {
      VEL = 5;
      for (var i = 1; i < alvo.g.length; i++) alvo.g[i] = m === 1 && i <= NP ? 1 : 0;
      alvo.ex = 0; marcaModo(); precisa = true;
      if (m === 1) { for (var q = 1; q <= NP; q++) if (FERRAGEM[q]) { avisa(FERRAGEM[q]); break; } }
    }
    for (var i = 0; i < navs.length; i++) liga(navs[i], 'click', function () {
      var m = Array.prototype.indexOf.call(navs, this); para(); usou(); modo(m);
    });
    if (alterna) liga(alterna, 'click', function () {
      para(); usou(); giroAlvo = 0; giroV = 0; cancelAnimationFrame(inercia); precisa = true;
      modo(alvo.g.some(function (v) { return v > 0; }) ? 0 : 1);
    });
    liga(caixaCores, 'click', function (e) {
      var b = e.target.closest('[data-p3d-cor]'); if (!b) return;
      var bs = caixaCores.querySelectorAll('[data-p3d-cor]');
      for (var k = 0; k < bs.length; k++) bs[k].setAttribute('aria-pressed', bs[k] === b ? 'true' : 'false');
      var c = hexDe(b.getAttribute('data-p3d-cor')); aplicaCor(c[0]); corNome.textContent = c[1];
      cor3d = c[0]; corAtual = c[0];
    });
    // a realidade aumentada de outra cor é o arquivo 3D do produto daquela cor: o endereço
    // vem das bolinhas de cor da ficha e o arquivo só é procurado quando a pessoa troca a cor
    var corPagina = raiz.getAttribute('data-cor') || '', cor3d = corPagina, arCor = {};
    function chaveCor(nome) {
      var n = (nome || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      var ks = ['nogal', 'grafite', 'verde', 'rosa', 'freijo', 'branco'];
      for (var i = 0; i < ks.length; i++) if (n.indexOf(ks[i]) > -1) return ks[i];
      return '';
    }
    function urlDaCor(k) {
      var as = document.querySelectorAll('.pick--cor a.sw[href], .opc--capa a.sw[href]');
      for (var i = 0; i < as.length; i++) if (chaveCor(as[i].getAttribute('title') || as[i].getAttribute('aria-label')) === k) return as[i].getAttribute('href');
      return '';
    }
    // o arquivo 3D de outro anúncio (busca uma vez por anúncio)
    var arH = raiz.__arH || (raiz.__arH = {});
    /* v198: o botão continua sendo o do ShopifyXR (é ele que abre a realidade aumentada no
       iPhone e no Android). Para outra combinação, o 3D daquele anúncio é registrado no
       ShopifyXR e o botão passa a apontar para ele; voltando à combinação da página, volta
       para o 3D da página. O arquivo vem de /products/<anúncio>?view=xr, no mesmo formato
       que a ficha usa. */
    function apontaAR(midia, titulo) {
      var bt = raiz.querySelector('.p3d__ar'); if (!bt || !window.ShopifyXR) return;
      if (!bt.getAttribute('data-ar-original')) { bt.setAttribute('data-ar-original', bt.getAttribute('data-shopify-model3d-id')); bt.setAttribute('data-ar-titulo', bt.getAttribute('data-shopify-title') || ''); }
      var id = midia ? String(midia.id) : bt.getAttribute('data-ar-original');
      if (bt.getAttribute('data-shopify-model3d-id') === id) return;
      try { if (midia) window.ShopifyXR.addModels([tamanhoReal(midia)]); } catch (e) {}
      // um botão novo, sem os ouvintes do anterior, para o ShopifyXR ligar de novo com o 3D certo
      var novo = bt.cloneNode(true);
      novo.setAttribute('data-shopify-model3d-id', id);
      novo.setAttribute('data-shopify-title', midia ? (titulo || '') : bt.getAttribute('data-ar-titulo'));
      bt.parentNode.replaceChild(novo, bt);
      try { window.ShopifyXR.setupXRElements(); } catch (e) {}
    }
    raiz.__preparaARh = function () {
      if (!raiz.querySelector('.p3d__ar')) return;
      var h = raiz.__arAlvo && raiz.__arAlvo(), eu = raiz.getAttribute('data-handle');
      if (!h || h === eu) { apontaAR(null); return; }
      if (arH[h] && arH[h] !== 'busca') { apontaAR(arH[h].m, arH[h].t); return; }
      if (arH[h] === 'busca' || arH[h] === null) { if (arH[h] === null) apontaAR(null); return; }
      arH[h] = 'busca';
      var raizLoja = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(raizLoja + 'products/' + h + '?view=xr', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var d = JSON.parse(t), m = ((d && d.m) || []).filter(function (x) { return x && x.media_type === 'model'; })[0];
          arH[h] = m ? { m: m, t: d.t || '' } : null;
          if (raiz.__arAlvo && raiz.__arAlvo() === h) apontaAR(m || null, d.t || '');
        })
        .catch(function () { arH[h] = null; });
    };
    function preparaAR(k) {
      if (!raiz.querySelector('.p3d__ar') || k === corPagina || arCor[k] !== undefined) return;
      var u = urlDaCor(k); if (!u) { arCor[k] = null; return; }
      arCor[k] = 'busca';
      fetch(u.split('?')[0].split('#')[0] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (pr) {
          var m = (pr.media || []).filter(function (x) { return x.media_type === 'model'; })[0], s = {};
          if (m) (m.sources || []).forEach(function (x) { s[x.format] = x.url; });
          arCor[k] = (s.usdz || s.glb) ? s : null;
        })
        .catch(function () { arCor[k] = null; });
    }
    /* v200: "Ver na minha casa" mais rápido.
       Na primeira vez, uma dica curta aparece antes da câmera (como apontar o celular), com
       o botão que abre de fato; depois, abre direto. No Android a câmera é aberta pelo tema,
       com o móvel travado no tamanho real e, nas peças de parede (espelho, armário, painel,
       prateleira), presa na parede. No iPhone quem abre continua sendo o ShopifyXR. */
    var ehAndroid = /android/i.test(navigator.userAgent);
    var ehParede = function () { return /^(armario|espelheira|espelho|dallas-painel|prateleira)/.test(raiz.getAttribute('data-chave') || ''); };
    function glbAtual() {
      var h = raiz.__arAlvo && raiz.__arAlvo(), m = null;
      if (h && h !== raiz.getAttribute('data-handle') && arH[h] && arH[h] !== 'busca') m = arH[h].m;
      if (!m) { var js = raiz.querySelector('[data-p3d-xr]'); try { m = (JSON.parse(js.textContent) || [])[0]; } catch (e) { m = null; } }
      var u = null; ((m && m.sources) || []).forEach(function (s) { if (s.format === 'glb') u = s.url; });
      return u;
    }
    function abreAndroid(glb, titulo) {
      var q = 'file=' + encodeURIComponent(glb) + '&mode=ar_preferred&resizable=false' + (ehParede() ? '&enable_vertical_placement=true' : '') + (titulo ? '&title=' + encodeURIComponent(titulo) : '');
      location.href = 'intent://arvr.google.com/scene-viewer/1.0?' + q + '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=' + encodeURIComponent(location.href) + ';end;';
    }
    var AR_DICA = 'onmArDica';
    function arJaViu() { try { return localStorage.getItem(AR_DICA) === '1'; } catch (e) { return true; } }
    function arViu() { try { localStorage.setItem(AR_DICA, '1'); } catch (e) {} }
    var arDicaEl = null;
    function escondeDicaAR() { if (arDicaEl) { arDicaEl.remove(); arDicaEl = null; } }
    function mostraDicaAR() {
      var bt = raiz.querySelector('.p3d__ar'); if (!bt) return;
      escondeDicaAR(); arViu();
      var parede = ehParede() && ehAndroid;
      arDicaEl = document.createElement('div'); arDicaEl.className = 'p3d__ardica'; arDicaEl.setAttribute('role', 'dialog'); arDicaEl.setAttribute('aria-label', 'Como ver o móvel na sua casa');
      // v202: o cartão explica o que vem (o móvel em 3D, no tamanho real, na casa da pessoa) e como apontar
      arDicaEl.innerHTML = '<b>Veja o móvel na sua casa</b>' +
        '<p>O 3D é feito do projeto da nossa fábrica e aparece no tamanho real, no lugar onde ele vai ficar.</p><ul>' +
        (parede ? '<li>Aponte o celular para a parede e mova devagar até ele aparecer.</li>' : '<li>Aponte o celular para o chão e mova devagar até ele aparecer.</li>') +
        (parede ? '<li>Parede lisa demora mais. Um quadro ou uma tomada por perto ajudam.</li>' : '<li>Com boa luz, ele aparece mais rápido.</li>') +
        '</ul><div class="p3d__ardica-b"></div><button type="button" class="p3d__ardica-x" data-p3d-dica-fecha>Agora não</button>';
      var abre = bt.cloneNode(true); abre.classList.remove('p3d__ar'); abre.classList.add('p3d__ar2'); abre.setAttribute('data-p3d-ar-abre', '');
      abre.removeAttribute('data-shopify-xr-hidden'); abre.hidden = false;
      abre.innerHTML = 'Abrir câmera';
      arDicaEl.querySelector('.p3d__ardica-b').appendChild(abre);
      (raiz.querySelector('.p3d__fixo') || raiz).appendChild(arDicaEl);
      try { if (window.ShopifyXR && !ehAndroid) window.ShopifyXR.setupXRElements(); } catch (e) {}
      abre.focus();
    }
    liga(raiz, 'click', function (e) {
      if (e.target.closest && e.target.closest('[data-p3d-dica-fecha]')) { escondeDicaAR(); return; }
      var bt = e.target.closest && e.target.closest('.p3d__ar, [data-p3d-ar-abre]'); if (!bt) return;
      if (!bt.hasAttribute('data-p3d-ar-abre') && !arJaViu()) { e.preventDefault(); e.stopImmediatePropagation(); mostraDicaAR(); return; }
      if (ehAndroid) {
        var glb = glbAtual();
        if (glb) { e.preventDefault(); e.stopImmediatePropagation(); escondeDicaAR(); abreAndroid(glb, bt.getAttribute('data-shopify-title') || ''); return; }
      }
      setTimeout(escondeDicaAR, 400);   // iPhone: o ShopifyXR abre a câmera com este mesmo toque
    }, true);
    tamanho(); marcaModo();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { colTexto = -1; precisa = true; });
    var visto = new IntersectionObserver(function (es) {
      if (morto) return;
      es.forEach(function (en) { var v = en.isIntersecting; if (v && !vivo) { vivo = true; precisa = true; requestAnimationFrame(quadro); } vivo = v; });
    }, { rootMargin: '200px 0px' });
    visto.observe(raiz); OBS.push(visto);
    var seq = [], emCena = false;
    function usou() { tocou = true; raiz.classList.add('p3d--usou'); raiz.classList.remove('p3d--dica'); if (dica) dica.classList.add('some'); }
    function para() { seq.forEach(clearTimeout); seq = []; }
    // onde tocar: a frente da primeira gaveta (ou a primeira porta) que abre
    var alvoEl = document.createElement('span'); alvoEl.className = 'p3d__alvo'; alvoEl.setAttribute('aria-hidden', 'true');
    // v184: a etiqueta clara vai junto da marca ("Clique para abrir"), no lugar do aviso escuro de cima
    var alvoT = document.createElement('span'); alvoT.className = 'p3d__alvo-t'; alvoEl.appendChild(alvoT);
    palco.appendChild(alvoEl);
    var alvoGrupo = null;
    (function () {
      var cand = Object.keys(D.gaveta || {}).filter(function (n) { return D.gaveta[n][0] === 1 && /^(ac\d*_)?frente/.test(n) && G[n]; });
      if (!cand.length) cand = Object.keys(PORTAS).filter(function (n) { return PORTAS[n].passo === 1 && G[n]; });
      if (!cand.length) cand = Object.keys(D.gaveta || {}).filter(function (n) { return D.gaveta[n][0] === 1 && G[n]; });
      alvoGrupo = cand[0] || null;
      // v182: sem porta nem gaveta (cuba, espelho, prateleira) não há onde tocar: a marca
      // não aparece; v184: fica só a etiqueta "Arraste para girar", embaixo no centro
      if (!alvoGrupo) alvoEl.classList.add('p3d__alvo--giro');
    })();
    var _pa = new THREE.Vector3();
    function posAlvo() {
      if (!alvoGrupo || !raiz.classList.contains('p3d--dica')) return;
      var g = G[alvoGrupo], c = g.userData.caixa;
      _pa.set((c.min.x + c.max.x) / 2, (c.min.y + c.max.y) / 2, c.max.z + 4);
      g.localToWorld(_pa); _pa.project(cam);
      var W = palco.clientWidth, H = palco.clientHeight;
      alvoEl.style.transform = 'translate(' + ((_pa.x + 1) / 2 * W).toFixed(1) + 'px,' + ((1 - _pa.y) / 2 * H).toFixed(1) + 'px)';
    }
    var temAmbos = temGav && temPorta;
    function textoDica() {
      if (!(temGav || temPorta)) return 'Arraste para girar';
      if (D.dicaAcao) return verbo + ' ' + D.dicaAcao;
      return verbo + (temAmbos ? ' na porta ou gaveta para abrir' : (temGav ? ' na gaveta para abrir' : ' na porta para abrir'));
    }
    function mostraDica() {
      if (!dica) return;
      dica.textContent = textoDica(); dica.classList.remove('some'); colTexto = -1;
      alvoT.textContent = alvoGrupo ? verbo + ' ' + (D.dicaAcao || 'para abrir') : 'Arraste para girar';
      raiz.classList.add('p3d--dica'); precisa = true;
    }
    // chegada: o móvel está aberto e fecha devagar enquanto o bloco entra na tela;
    // a marca de toque e o aviso aparecem junto, no primeiro segundo
    function apresenta() {
      if (emCena) return; emCena = true; tocou = false; raiz.classList.remove('p3d--usou');
      mostraDica();
      if (REDUZ || !(temGav || temPorta)) return;
      VEL = 1.9;
      seq.push(setTimeout(function () { for (var s = 1; s <= NP; s++) alvo.g[s] = 0; marcaModo(); precisa = true; }, 120));
      seq.push(setTimeout(function () { VEL = 5; }, 2400));
    }
    // fora da tela de vez: volta a ficar aberto, para fechar de novo na próxima chegada
    function reabre() {
      emCena = false; para(); if (REDUZ || !(temGav || temPorta)) return;
      giroAlvo = 0; giro = 0; giroV = 0;
      for (var s = 1; s <= NP; s++) { cur.g[s] = 1; alvo.g[s] = 1; } cur.ga = 1; alvo.ex = 0; cur.ex = 0; marcaModo(); precisa = true;
    }
    var html = document.documentElement, emFoco = false, fixo = raiz.querySelector('.p3d__fixo') || palco;
    var foco = new IntersectionObserver(function (es) {
      if (morto) return;
      es.forEach(function (en) {
        var r = en.intersectionRatio;
        if (r > .45) apresenta();
        if (!en.isIntersecting) reabre();
        // a barra de compra e a do acordeão saem com o palco inteiro na tela e só voltam quando ele vai embora
        if (!emFoco && r > .82) { emFoco = true; html.classList.add('p3dFoco'); }
        else if (emFoco && r < .5) { emFoco = false; html.classList.remove('p3dFoco'); }
      });
    }, { threshold: [0, .1, .3, .45, .5, .7, .82, .9, 1] });
    foco.observe(fixo); OBS.push(foco);
    var seguir = raiz.querySelector('[data-p3d-seguir]');
    if (seguir) liga(seguir, 'click', function () {
      ativo = false; palco.style.touchAction = '';
      var r = raiz.getBoundingClientRect(); window.scrollTo({ top: window.scrollY + r.bottom - 8, behavior: REDUZ ? 'auto' : 'smooth' });
    });
    /* ═══ v191 · o 3D vira um montador: medida, cuba, peça de cima, cor ═══════════
       Linhas discretas embaixo das cores. Só aparece o que vale para o móvel. Quando a
       combinação montada tem anúncio de verdade, aparece o link para ele. */
    var ctrl = raiz.querySelector('.p3d__ctrl') || caixaCores.parentNode;
    var opcEl = document.createElement('div'); opcEl.className = 'p3d__opc';
    var TAMS = []; try { TAMS = JSON.parse(raiz.getAttribute('data-tamanhos') || '[]'); } catch (e) { TAMS = []; }
    var chaveAtual = raiz.getAttribute('data-chave');
    if (!raiz.getAttribute('data-chave-original')) {
      raiz.setAttribute('data-chave-original', chaveAtual); raiz.setAttribute('data-cor-original', corAtual);
      raiz.setAttribute('data-config-original', cfg); raiz.setAttribute('data-kit-original', raiz.getAttribute('data-kit-spec') || '');
    }
    var tamAtual = TAMS.filter(function (t) { return t.k === chaveAtual; })[0] || null;
    var kitSpec = raiz.getAttribute('data-kit-spec') || '';
    var naoLinha = /(_torneira|_ralo|^tv$|_tv$)/, cubaG = /^(chanel|plena_[ab]|chanel_[ab])$/;
    function grupoCorpo(n) { return !/^ac\d*_/.test(n) && !naoLinha.test(n) && !cubaG.test(n) && !/_det$/.test(n); }
    function caixaDeGrupos(teste) {
      var b = new THREE.Box3(), t = new THREE.Box3();
      Object.keys(G).forEach(function (n) { if (G[n].visible && teste(n)) { caixaDe(n, t); b.union(t); } });
      return b;
    }
    function corpoBox(semPesC) {
      var b = caixaDeGrupos(function (n) { return grupoCorpo(n) && !(semPesC && /^pe_/.test(n)); });
      if (b.isEmpty()) b = caixaDeGrupos(function (n) { return !/^ac\d*_/.test(n) && !naoLinha.test(n); });   // a peça é a própria cuba
      return b;
    }
    // pés: o Milano já vem com eles; Dubai e Paris são suspensos e os pés são vendidos à parte
    var PES = (D.pesOpcional || D.pesVendidos) ? Object.keys(G).filter(function (n) { return /^pe_/.test(n); }) : [];
    var RALOS = [];
    function achaRalos() {
      RALOS = []; var t = new THREE.Box3(), c = new THREE.Vector3();
      Object.keys(G).forEach(function (n) {
        if (!G[n].visible || /^ac\d*_/.test(n)) return;
        if (n === 'pia_ralo' || cubaG.test(n) || (n === 'pia' && !G.pia_ralo)) {
          caixaDe(n, t); t.getCenter(c); RALOS.push(new THREE.Vector3(c.x, n === 'pia_ralo' ? t.min.y + 4 : t.min.y, c.z));
        }
      });
    }
    var vis = { medidas: false, pes: !!D.pesOpcional, cano: false, saida: 'parede', amb: 'estudio' };
    try { var vs = JSON.parse(raiz.getAttribute('data-vis') || '{}'); vis.medidas = !!vs.medidas; if (vs.pes != null && PES.length) vis.pes = !!vs.pes; vis.saida = vs.saida || 'parede'; } catch (e) {}
    function guardaVis() { raiz.setAttribute('data-vis', JSON.stringify({ medidas: vis.medidas, pes: vis.pes, saida: vis.saida, amb: vis.amb })); }
    try { var vsA = JSON.parse(raiz.getAttribute('data-vis') || '{}'); if (vsA.amb) vis.amb = vsA.amb; } catch (e) {}

    /* ═══ v205 · ambientes desenhados aqui mesmo, leves e discretos ═══════════════════
       O estúdio (o fundo de sempre, da marca) continua sendo o padrão. Cinco estilos
       (Minimalista, Contemporâneo, Industrial, Boho e Japandi), cada um com parede e piso
       próprios para banheiro e para sala. As texturas são desenhadas na hora, em tons
       suaves (nada de foto pesada), e a ordem muda conforme a cor do móvel: primeiro as
       que mais combinam com ela. O botão "Ambiente" troca a cada toque. */
    var CH = raiz.getAttribute('data-chave') || '';
    var ehBanho = /^(milano|dubai|paris|moscou|armario|espelh)/.test(CH);
    var clarinho = corAtual === 'branco';   // móvel branco: as paredes claras ficam um tom abaixo, para ele não sumir
    function tom(hex, f) { var n = parseInt(hex.slice(1), 16), r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255; return '#' + [r, g, b].map(function (v) { return ('0' + Math.max(0, Math.min(255, Math.round(v * f))).toString(16)).slice(-2); }).join(''); }
    function claro(hex) { return clarinho ? tom(hex, .93) : hex; }
    var ESTILOS = ehBanho ? {
      minimal: { n: 'Minimalista', parede: ['placas', claro('#e9e6e1'), 1200, 600], piso: ['placas', '#d6d2cb', 900, 900] },
      contemp: { n: 'Contemporâneo', parede: ['metro', '#f4f3f0'], piso: ['placas', '#bfbcb7', 600, 600] },
      industrial: { n: 'Industrial', parede: ['concreto', '#b9b6b0'], piso: ['madeira', '#8a6446'] },
      boho: { n: 'Boho', parede: ['zellige', '#dccab4'], piso: ['terracota', '#c9825e'] },
      japandi: { n: 'Japandi', parede: ['reboco', claro('#ece6dc')], piso: ['madeira', '#c9a982'] }
    } : {
      minimal: { n: 'Minimalista', parede: ['pintura', claro('#efebe5')], piso: ['concreto', '#d4d0ca'], rodape: claro('#f1eee9') },
      contemp: { n: 'Contemporâneo', parede: ['pintura', '#d6cec3'], piso: ['madeira', '#a77d58'], rodape: '#ebe6de' },
      industrial: { n: 'Industrial', parede: ['tijolo', '#9a6a58'], piso: ['concreto', '#a19e98'], escuro: true },
      boho: { n: 'Boho', parede: ['pintura', '#c99474'], piso: ['madeira', '#c9a982'], rodape: '#e9dccf', tapete: true },
      japandi: { n: 'Japandi', parede: ['reboco', claro('#e4ded2')], piso: ['madeira', '#c9a982'], rodape: '#f0ebe3' }
    };
    var ORDEM_COR = {
      branco: ['contemp', 'japandi', 'boho', 'industrial', 'minimal'],
      grafite: ['japandi', 'boho', 'minimal', 'contemp', 'industrial'],
      verde: ['japandi', 'boho', 'minimal', 'contemp', 'industrial'],
      rosa: ['boho', 'japandi', 'minimal', 'contemp', 'industrial'],
      freijo: ['minimal', 'industrial', 'contemp', 'japandi', 'boho']
    };
    var ordem = ORDEM_COR[corAtual] || ['japandi', 'minimal', 'contemp', 'industrial', 'boho'];
    var AMBS = /^cuba-/.test(CH) ? [] : [['estudio', 'Estúdio']].concat(ordem.map(function (k) { return [k, ESTILOS[k].n]; }));
    if (!AMBS.some(function (a) { return a[0] === vis.amb; })) vis.amb = 'estudio';
    // onde fica o chão: as peças de parede sobem até a altura em que costumam ser instaladas
    var pisoY = /^(espelh|armario)/.test(CH) ? -1100 : (/^prateleira/.test(CH) ? -1400 : (/^dallas-painel/.test(CH) ? -350 : 0));
    // o tamanho real de cada desenho (mm), para azulejo, placa e tábua ficarem na escala certa
    function escala(s) { return s[0] === 'placas' ? s[2] * 2 : ({ metro: 600, madeira: 1520, terracota: 1200, zellige: 400, tijolo: 1300, concreto: 1800, reboco: 1600, pintura: 1600, tapete: 2000 })[s[0]]; }
    function texDesenho(s) {
      var chave = s.join('|'), cache = window.__onmTexAmb || (window.__onmTexAmb = {}); if (cache[chave]) return cache[chave];
      var c = document.createElement('canvas'); c.width = c.height = 512; var x = c.getContext('2d'), tipo = s[0], cor = s[1];
      var sorte = 11; function rnd() { sorte = (sorte * 16807) % 2147483647; return sorte / 2147483647; }
      function ruido(a, n) { for (var i = 0; i < n; i++) { x.fillStyle = (rnd() < .5 ? 'rgba(0,0,0,' : 'rgba(255,255,255,') + (rnd() * a).toFixed(3) + ')'; x.fillRect(rnd() * 512, rnd() * 512, 1 + rnd() * 2, 1 + rnd() * 2); } }
      function manchas(rgb, n, rM, a) { for (var i = 0; i < n; i++) { var px = rnd() * 512, py = rnd() * 512, r = 10 + rnd() * rM, g = x.createRadialGradient(px, py, 0, px, py, r); g.addColorStop(0, 'rgba(' + rgb + ',' + (rnd() * a).toFixed(3) + ')'); g.addColorStop(1, 'rgba(' + rgb + ',0)'); x.fillStyle = g; for (var ox = -512; ox <= 512; ox += 512) for (var oy = -512; oy <= 512; oy += 512) x.fillRect(px - r + ox, py - r + oy, 2 * r, 2 * r); } }
      function var1(hex, d) { return tom(hex, 1 + (rnd() - .5) * d); }
      x.fillStyle = cor; x.fillRect(0, 0, 512, 512);
      if (tipo === 'pintura') { ruido(.018, 3000); }
      else if (tipo === 'reboco') { manchas('0,0,0', 40, 70, .035); manchas('255,255,255', 40, 70, .05); ruido(.03, 7000); }
      else if (tipo === 'concreto') { manchas('0,0,0', 70, 80, .06); manchas('255,255,255', 50, 70, .06); ruido(.04, 8000); }
      else if (tipo === 'placas') {
        var nx = 2, ny = Math.max(1, Math.round(2 * s[2] / s[3])), w = 512 / nx, h = 512 / ny;
        for (var i = 0; i < nx; i++) for (var k = 0; k < ny; k++) { x.fillStyle = var1(cor, .025); x.fillRect(i * w + 1, k * h + 1, w - 2, h - 2); }
        x.fillStyle = tom(cor, .9); for (i = 0; i <= nx; i++) x.fillRect(i * w - 1, 0, 2, 512); for (k = 0; k <= ny; k++) x.fillRect(0, k * h - 1, 512, 2);
        manchas('0,0,0', 25, 60, .02); ruido(.02, 3000);
      } else if (tipo === 'metro') {
        x.fillStyle = tom(cor, .9); x.fillRect(0, 0, 512, 512);
        for (var r2 = 0; r2 < 8; r2++) for (var k2 = -1; k2 < 5; k2++) { x.fillStyle = var1(cor, .02); x.fillRect(k2 * 128 + (r2 % 2) * 64 + 2, r2 * 64 + 2, 124, 60); }
        ruido(.02, 2000);
      } else if (tipo === 'zellige') {
        x.fillStyle = tom(cor, .9); x.fillRect(0, 0, 512, 512);
        for (var a = 0; a < 8; a++) for (var b = 0; b < 8; b++) { x.fillStyle = var1(cor, .07); x.fillRect(a * 64 + 2, b * 64 + 2, 60, 60); }
        manchas('255,255,255', 60, 30, .08); ruido(.02, 2500);
      } else if (tipo === 'terracota') {
        x.fillStyle = tom(cor, .82); x.fillRect(0, 0, 512, 512);
        for (var a2 = 0; a2 < 4; a2++) for (var b2 = 0; b2 < 4; b2++) { x.fillStyle = var1(cor, .1); x.fillRect(a2 * 128 + 2, b2 * 128 + 2, 124, 124); }
        manchas('0,0,0', 30, 40, .05); ruido(.03, 4000);
      } else if (tipo === 'tijolo') {
        x.fillStyle = '#c9c1b8'; x.fillRect(0, 0, 512, 512);
        for (var r3 = 0; r3 < 16; r3++) for (var k3 = -1; k3 < 5; k3++) { x.fillStyle = var1(cor, .14); x.fillRect(k3 * 128 + (r3 % 2) * 64 + 3, r3 * 32 + 3, 122, 26); }
        manchas('0,0,0', 40, 60, .06); ruido(.04, 5000);
      } else if (tipo === 'madeira') {
        for (var tb = 0; tb < 8; tb++) {
          x.fillStyle = var1(cor, .07); x.fillRect(0, tb * 64, 512, 64);
          for (var l = 0; l < 12; l++) { x.strokeStyle = 'rgba(60,35,15,' + (.025 + rnd() * .045).toFixed(3) + ')'; x.lineWidth = 1; x.beginPath(); var yy = tb * 64 + rnd() * 64, fase = rnd() * 9; x.moveTo(0, yy); for (var px = 0; px <= 512; px += 32) x.lineTo(px, yy + Math.sin(px / 80 + fase) * 1.8); x.stroke(); }
          x.fillStyle = 'rgba(40,24,10,.18)'; x.fillRect(0, tb * 64, 512, 1); x.fillRect((rnd() * 512) | 0, tb * 64, 1, 64);
        }
      } else if (tipo === 'tapete') {
        x.fillStyle = '#e8dccb'; x.fillRect(0, 0, 512, 512);
        ['#c99474', '#8f9b85', '#d9b98f'].forEach(function (cc, i) { x.fillStyle = cc; x.globalAlpha = .55; x.fillRect(0, 80 + i * 130, 512, 14); x.fillRect(0, 100 + i * 130, 512, 4); });
        x.globalAlpha = 1; ruido(.05, 9000);
      }
      var tx = new THREE.CanvasTexture(c); tx.wrapS = tx.wrapT = THREE.RepeatWrapping; tx.anisotropy = 4;
      if ('colorSpace' in tx) tx.colorSpace = THREE.SRGBColorSpace;
      cache[chave] = tx; return tx;
    }
    var ambGrupo = null;
    function aplicaAmbiente() {
      if (ambGrupo) { cena.remove(ambGrupo); ambGrupo.traverse(function (o) { if (o.geometry) o.geometry.dispose(); if (o.material) { if (o.material.map) o.material.map.dispose(); o.material.dispose(); } }); ambGrupo = null; }
      var def = ESTILOS[vis.amb], est = !def;
      chao.visible = est; if (typeof parede !== 'undefined' && parede) parede.visible = est;
      if (paredePes) paredePes.visible = est && !vis.pes && !D.suspenso;
      raiz.classList.toggle('p3d--amb', !est);
      // v208: o texto do alto fica sobre a parede e o menu de baixo sobre o piso: cada um claro ou escuro pelo fundo dele
      function escuro(hex) { var n = parseInt(hex.slice(1), 16), r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255; return (.2126 * r + .7152 * g + .0722 * b) < .5; }
      raiz.classList.toggle('p3d--escuro', !est && escuro(def.parede[1]));
      raiz.classList.toggle('p3d--base-escura', !est && escuro(def.piso[1]));
      if (est) { raiz.style.removeProperty('--p3d-amb'); precisa = true; return; }
      // o fundo do bloco acompanha o ambiente: o que o 3D não cobre (bordas, fim da rolagem) não quebra
      raiz.style.setProperty('--p3d-amb', 'linear-gradient(180deg,' + def.parede[1] + ' 0%,' + def.parede[1] + ' 55%,' + def.piso[1] + ' 72%,' + def.piso[1] + ' 100%)');
      var gr = new THREE.Group(), zP = minZ - 2, L = 40000, A = 9000;
      function superficie(s, w, h) {
        var t = texDesenho(s).clone(); t.needsUpdate = true; var e = escala(s); t.repeat.set(w / e, h / e);
        return new THREE.MeshStandardMaterial({ map: t, roughness: s[0] === 'placas' || s[0] === 'metro' || s[0] === 'zellige' ? .45 : .88, metalness: 0 });
      }
      var piso = new THREE.Mesh(new THREE.PlaneGeometry(L, L), superficie(def.piso, L, L));
      piso.rotation.x = -Math.PI / 2; piso.position.set(0, pisoY, zP + L / 2); piso.receiveShadow = true; gr.add(piso);
      var pa = new THREE.Mesh(new THREE.PlaneGeometry(L, A), superficie(def.parede, L, A));
      pa.position.set(0, pisoY + A / 2, zP); pa.receiveShadow = true; gr.add(pa);
      if (def.rodape) {
        var rd = new THREE.Mesh(new THREE.BoxGeometry(L, 90, 14), new THREE.MeshStandardMaterial({ color: def.rodape, roughness: .6 }));
        rd.position.set(0, pisoY + 45, zP + 7); rd.receiveShadow = true; gr.add(rd);
      }
      // boho: um tapete na frente do móvel (só nos que ficam no chão)
      if (def.tapete && pisoY === 0) {
        var bx = new THREE.Box3(); Object.keys(G).forEach(function (n) { if (G[n].visible && !/^ac\d*_/.test(n)) { var t2 = new THREE.Box3(); caixaDe(n, t2); bx.union(t2); } });
        if (!bx.isEmpty()) {
          var tw = Math.max(1600, (bx.max.x - bx.min.x) + 700), td = 1200;
          var tp = new THREE.Mesh(new THREE.PlaneGeometry(tw, td), superficie(['tapete', '#e8dccb'], tw, td));
          tp.rotation.x = -Math.PI / 2; tp.position.set((bx.min.x + bx.max.x) / 2, 2, bx.max.z + td / 2 + 120); tp.receiveShadow = true; gr.add(tp);
        }
      }
      decora(def, gr, zP);
      cena.add(gr); ambGrupo = gr; precisa = true;
    }
    /* v207: decoração bem leve, que muda com o estilo. Formas simples (vaso, planta, quadro,
       toalha, livros), em tons suaves, sempre ao lado do móvel ou em cima dele sem encostar
       na TV nem na cuba. Peças de parede ganham só o que cabe nelas (livros na prateleira). */
    var PAL = {
      japandi: { vaso: '#e6dfd2', folha: '#7f8b6b', quadro: '#efe9de', tinta: '#3d3a36', toalha: '#e9e2d6', moldura: '#c9a982' },
      minimal: { vaso: '#f3f1ed', folha: '#8a9579', quadro: '#f6f4f0', tinta: '#262626', toalha: '#f2f0ec', moldura: '#1f1f1f' },
      contemp: { vaso: '#d9d1c7', folha: '#768a6c', quadro: '#ece5dc', tinta: '#b9714b', toalha: '#d8cfc4', moldura: '#b8b0a6', livros: ['#c9b8a6', '#7c8a94', '#d8cfc4'] },
      industrial: { vaso: '#7f7c77', folha: '#5f7652', quadro: '#3a3a3a', tinta: '#d9d4cc', toalha: '#9a9792', moldura: '#1c1c1c', livros: ['#4a4a4a', '#9b8f84', '#c2bab0'] },
      boho: { vaso: '#c49a6c', folha: '#6f8a5a', quadro: '#efe2d0', tinta: '#c7774f', toalha: '#e8d9c3', moldura: '#b07d55', cesto: true }
    };
    function decora(def, gr, zP) {
      var pal = PAL[vis.amb]; if (!pal) return;
      function mat(cor, rug) { return new THREE.MeshStandardMaterial({ color: cor, roughness: rug == null ? .8 : rug, metalness: 0 }); }
      function poe(m, x, y, z) { m.position.set(x, y, z); m.castShadow = true; m.receiveShadow = true; gr.add(m); return m; }
      // v208: vasos torneados (bojudo, reto com borda ou garrafa) e plantas com forma de planta
      var PERFIS = {
        bojudo: [[.0, 0], [.62, 0], [.9, .18], [1, .45], [.9, .75], [.66, .93], [.7, 1], [0, 1]],
        reto: [[0, 0], [.86, 0], [.92, .06], [1, .92], [1.06, 1], [0, 1]],
        garrafa: [[0, 0], [.7, 0], [1, .25], [.95, .55], [.45, .78], [.32, .9], [.38, 1], [0, 1]]
      };
      function vaso(x, y, z, h, r, cor, perfil) {
        var pts = (PERFIS[perfil] || PERFIS.reto).map(function (q) { return new THREE.Vector2(Math.max(.5, q[0] * r), q[1] * h); });
        return poe(new THREE.Mesh(new THREE.LatheGeometry(pts, 28), mat(cor, .55)), x, y, z);
      }
      function planta(x, y, z, s, cor, tipo) {
        var tons = [cor, tom(cor, .82), tom(cor, 1.12)];
        if (tipo === 'espada') {                 // espada-de-são-jorge: folhas altas e finas, abrindo um pouco
          for (var i = 0; i < 9; i++) {
            var a = i / 9 * Math.PI * 2, h = s * (2.1 + (i % 3) * .45);
            var f = new THREE.Mesh(new THREE.ConeGeometry(s * .16, h, 4), mat(tons[i % 3], .8)); f.scale.z = .28;
            f.rotation.y = a; f.rotation.z = Math.sin(a) * .16; f.rotation.x = Math.cos(a) * .16;
            poe(f, x + Math.cos(a) * s * .18, y + h / 2, z + Math.sin(a) * s * .18);
          }
          return;
        }
        var g = new THREE.IcosahedronGeometry(1, 1);
        [[0, .95, 0, .9], [-.6, .7, .25, .7], [.55, .72, -.2, .74], [.1, 1.4, .1, .62], [-.25, .5, -.45, .55], [.4, .45, .45, .55], [-.45, 1.15, -.15, .5], [.45, 1.15, .2, .5]].forEach(function (f, i) {
          var o = new THREE.Mesh(g, mat(tons[i % 3], .9)); o.scale.set(s * f[3], s * f[3] * .8, s * f[3]); o.rotation.set(i, i * 2, 0); poe(o, x + f[0] * s, y + f[1] * s, z + f[2] * s);
        });
      }
      // vaso sanitário de louça, encostado na parede (banheiro)
      function sanitario(x, z) {
        var lou = mat('#f4f4f2', .22);
        var pe = new THREE.Mesh(new THREE.CylinderGeometry(140, 120, 380, 28), lou); pe.scale.z = 1.45; poe(pe, x, 190, z + 300);
        var assento = new THREE.Mesh(new THREE.CylinderGeometry(180, 172, 45, 32), lou); assento.scale.z = 1.32; poe(assento, x, 402, z + 300);
        var caixa = new THREE.Mesh(new THREE.BoxGeometry(380, 380, 165), lou); poe(caixa, x, 590, z + 95);
        var tampa = new THREE.Mesh(new THREE.BoxGeometry(392, 22, 175), lou); poe(tampa, x, 791, z + 95);
        var bt = new THREE.Mesh(new THREE.CylinderGeometry(22, 22, 8, 20), mat('#b8bec4', .3)); poe(bt, x, 806, z + 95);
      }
      function galho(x, y, z, h, cor) {
        var mg = mat('#5b4a3c', .9);
        [[-.18, .12], [.1, -.08], [.22, .16]].forEach(function (a, i) {
          var c = new THREE.Mesh(new THREE.CylinderGeometry(3, 4, h * (1 - i * .15), 6), mg); c.rotation.z = a[0]; c.rotation.x = a[1];
          poe(c, x + Math.sin(a[0]) * -h * .45, y + h * .45 * (1 - i * .15), z + Math.sin(a[1]) * h * .45);
          for (var k = 0; k < 4; k++) { var f = new THREE.Mesh(new THREE.SphereGeometry(18, 8, 6), mat(cor, .9)); f.scale.set(1, .5, .8); poe(f, x - Math.sin(a[0]) * h * (.55 + k * .12), y + h * (.55 + k * .1) * (1 - i * .15), z + Math.sin(a[1]) * h * (.5 + k * .1)); }
        });
      }
      function livros(x, y, z, cores) {
        var hy = y; (cores || ['#cdbfae', '#8c9a9f', '#e2d9cc']).forEach(function (c, i) {
          var b = new THREE.Mesh(new THREE.BoxGeometry(210 - i * 18, 28, 150 - i * 8), mat(c, .85)); b.rotation.y = (i - 1) * .12; poe(b, x, hy + 14, z); hy += 28;
        });
        return hy;
      }
      function quadro(x, y, z, w, h) {
        var c = document.createElement('canvas'); c.width = 256; c.height = 320; var q = c.getContext('2d');
        q.fillStyle = pal.quadro; q.fillRect(0, 0, 256, 320); q.strokeStyle = pal.tinta; q.fillStyle = pal.tinta; q.lineWidth = 6; q.lineCap = 'round';
        if (vis.amb === 'japandi') { q.globalAlpha = .85; q.beginPath(); q.arc(128, 150, 70, .3, 5.6); q.stroke(); }
        else if (vis.amb === 'minimal') { q.lineWidth = 3; q.beginPath(); q.moveTo(60, 230); q.bezierCurveTo(90, 90, 170, 260, 200, 90); q.stroke(); }
        else if (vis.amb === 'contemp') { q.globalAlpha = .8; q.fillRect(50, 70, 110, 140); q.fillStyle = '#8a9a86'; q.beginPath(); q.arc(170, 210, 55, 0, 6.3); q.fill(); }
        else if (vis.amb === 'industrial') { q.lineWidth = 3; for (var i = 0; i < 6; i++) { q.beginPath(); q.moveTo(40, 60 + i * 40); q.lineTo(216, 40 + i * 44); q.stroke(); } }
        else { q.globalAlpha = .85; q.beginPath(); q.arc(128, 230, 80, Math.PI, 0); q.fill(); q.fillStyle = '#d9a650'; q.beginPath(); q.arc(128, 120, 34, 0, 6.3); q.fill(); }
        var t = new THREE.CanvasTexture(c); if ('colorSpace' in t) t.colorSpace = THREE.SRGBColorSpace;
        poe(new THREE.Mesh(new THREE.BoxGeometry(w + 40, h + 40, 22), mat(pal.moldura, .6)), x, y, z + 11);
        var tela = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshStandardMaterial({ map: t, roughness: .9 }));
        tela.position.set(x, y, z + 23); gr.add(tela);
      }
      function toalha(x, y, z) {
        var barra = new THREE.Mesh(new THREE.CylinderGeometry(7, 7, 460, 12), mat('#a9b0b6', .35)); barra.rotation.z = Math.PI / 2; poe(barra, x, y, z + 50);
        poe(new THREE.Mesh(new THREE.BoxGeometry(380, 520, 30), mat(pal.toalha, .95)), x, y - 250, z + 50);
      }
      // o móvel principal (sem as peças de cima), e com elas, para não pôr nada em cima de um painel
      var bx = new THREE.Box3(), todo = new THREE.Box3(), t2 = new THREE.Box3();
      Object.keys(G).forEach(function (n) {
        if (!G[n].visible || /(torneira|ralo|^tv$|_tv$)/.test(n)) return;
        caixaDe(n, t2); todo.union(t2); if (!/^ac\d*_/.test(n)) bx.union(t2);
      });
      if (bx.isEmpty()) return;
      var temTV = !!(G.tv && G.tv.visible), noChao = pisoY === 0;
      if (/^prateleira/.test(CH)) {             // na prateleira: livros num canto e um vaso pequeno no outro
        var yTopo = bx.max.y, zMeio = (bx.min.z + bx.max.z) / 2;
        livros(bx.min.x + 160, yTopo, zMeio, pal.livros);
        vaso(bx.max.x - 120, yTopo, zMeio, 120, 48, pal.vaso, 'bojudo');
        if (vis.amb !== 'minimal') planta(bx.max.x - 120, yTopo + 118, zMeio, 40, pal.folha, vis.amb === 'industrial' || vis.amb === 'contemp' ? 'espada' : '');
        return;
      }
      if (!noChao) return;                        // espelhos, armários e painéis: a peça sozinha já basta
      var dir = todo.max.x, esq = todo.min.x;
      if (ehBanho) {
        // o sanitário fica do lado direito (no computador o lado esquerdo é do texto); a toalha e a planta do outro lado
        sanitario(dir + 560, zP);
        toalha(esq - 330, 1050, zP);
        if (vis.amb === 'boho' || vis.amb === 'japandi') { vaso(esq - 330, 0, zP + 330, 260, 130, pal.vaso, 'bojudo'); planta(esq - 330, 255, zP + 330, 95, pal.folha); }
        // plantinha no tampo, se sobra espaço ao lado da cuba
        var tp = new THREE.Box3(), cb = new THREE.Box3(), t3 = new THREE.Box3();
        Object.keys(G).forEach(function (n) { if (!G[n].visible) return; if (/^tampo/.test(n)) { caixaDe(n, t3); tp.union(t3); } if (/^(chanel|plena_[ab]|chanel_[ab])$/.test(n)) { caixaDe(n, t3); cb.union(t3); } });
        if (!tp.isEmpty() && !cb.isEmpty()) {
          var livreE = cb.min.x - tp.min.x, livreD = tp.max.x - cb.max.x, zc = (tp.min.z + tp.max.z) / 2 - 20;
          var xs = livreD >= livreE ? (cb.max.x + tp.max.x) / 2 : (tp.min.x + cb.min.x) / 2;
          if (Math.max(livreE, livreD) > 170) { vaso(xs, tp.max.y, zc, 85, 42, pal.vaso, 'reto'); planta(xs, tp.max.y + 82, zc, 34, pal.folha); }
        }
        return;
      }
      // sala: planta no chão ao lado, quadro na parede do outro lado e, sem TV, algo em cima
      if (vis.amb !== 'minimal') {
        var esp = vis.amb === 'industrial' || vis.amb === 'contemp', hv = pal.cesto ? 260 : (esp ? 330 : 380);
        vaso(dir + 380, 0, zP + 230, hv, pal.cesto ? 150 : 125, pal.vaso, pal.cesto ? 'reto' : (esp ? 'reto' : 'bojudo'));
        planta(dir + 380, hv - 5, zP + 230, esp ? 120 : 115, pal.folha, esp ? 'espada' : '');
      }
      var alto = todo.max.y - pisoY;
      if (alto < 1250) quadro(esq - 480, Math.max(1350, todo.max.y + 500), zP, 460, 600);
      if (!temTV && bx.max.y < 1300) {
        var yT = bx.max.y, zT = (bx.min.z + bx.max.z) / 2 + 20;
        if (vis.amb === 'japandi' || vis.amb === 'minimal') { vaso(bx.min.x + 160, yT, zT, 240, 62, pal.vaso, 'garrafa'); galho(bx.min.x + 160, yT + 230, zT, 380, pal.folha); }
        else if (pal.livros) { var yL = livros(bx.max.x - 200, yT, zT, pal.livros); vaso(bx.max.x - 200, yL, zT, 95, 42, pal.vaso, 'bojudo'); }
        else { vaso(bx.min.x + 170, yT, zT, 140, 72, pal.vaso, 'bojudo'); planta(bx.min.x + 170, yT + 136, zT, 66, pal.folha); }
      }
    }
    var paredePes = null;
    function aplicaPes() {
      PES.forEach(function (n) { G[n].visible = vis.pes; });
      baixaY = (D.pesVendidos && vis.pes) ? (D.pesDesce || 0) : 0;
      var sus = !vis.pes;
      if (sus && !D.suspenso && !paredePes) {
        paredePes = new THREE.Mesh(new THREE.PlaneGeometry(9000, 9000), new THREE.ShadowMaterial({ opacity: .1 }));
        paredePes.position.set(0, 0, minZ - 2); paredePes.receiveShadow = true; cena.add(paredePes);
      }
      if (paredePes) paredePes.visible = sus;
      aplica(estado()); montaCotas(); if (vis.cano) refazCanos(); precisa = true;
    }

    // medidas: as do cadastro de cada peça (gabinete, peça de cima, cuba), com linhas finas
    var cotas = new THREE.Group(); cotas.visible = false; cena.add(cotas);
    var matCota = new THREE.LineBasicMaterial({ color: 0x1c1c1c, transparent: true, opacity: .55, depthTest: false });
    var cotaEls = [], COTAS = [];
    function cm(v) { var x = Math.round(v * 2) / 2; return (x % 1 ? x.toFixed(1).replace('.', ',') : x.toFixed(0)); }
    function seg(a, b, tq) {
      var pts = [a, b]; [a, b].forEach(function (p) { pts.push(p.clone().sub(tq), p.clone().add(tq)); });
      var g = new THREE.BufferGeometry().setFromPoints(pts); g.setIndex([0, 1, 2, 3, 4, 5]);
      var l = new THREE.LineSegments(g, matCota); l.renderOrder = 10; cotas.add(l);
    }
    function cota(a, b, tq, txt) { seg(a, b, tq); COTAS.push({ p: a.clone().add(b).multiplyScalar(.5), t: txt }); }
    function rotulo(pt, txt) { COTAS.push({ p: pt, t: txt }); }
    function montaCotas() {
      while (cotas.children.length) { var o = cotas.children.pop(); o.geometry.dispose(); }
      COTAS = []; var V = THREE.Vector3, f = 60, M = D.medidas;
      var b = corpoBox(!vis.pes);
      if (!b.isEmpty() && M) {
        var y0 = b.min.y, alt = M.a + (vis.pes && PES.length && !M.pesNaAltura ? (M.pes || 20) : 0);
        var piso = vis.pes && PES.length ? 0 : b.min.y;
        cota(new V(b.min.x, y0, b.max.z + f), new V(b.max.x, y0, b.max.z + f), new V(0, 0, 18), cm(M.l) + ' cm');
        if (M.a >= 5) cota(new V(b.max.x + f, piso, b.max.z), new V(b.max.x + f, b.max.y, b.max.z), new V(18, 0, 0), cm(alt) + ' cm');
        if (M.p >= 5) cota(new V(b.max.x + f, y0, b.min.z), new V(b.max.x + f, y0, b.max.z), new V(18, 0, 0), cm(M.p) + ' cm');
      }
      // as peças de cima (armário, espelho, painel, prateleira); peças iguais lado a lado
      // levam a altura só na última, para não repetir o número
      var acs = Object.keys(D.medAc || {}).map(function (pfx) {
        var m = D.medAc[pfx]; if (!m) return null;
        var ba = caixaDeGrupos(function (n) { return n.indexOf(pfx + '_') === 0 && !naoLinha.test(n); });
        if (D.medidas && m.l === D.medidas.l && m.a === D.medidas.a && m.p === D.medidas.p) return null;
        return ba.isEmpty() ? null : { m: m, b: ba };
      }).filter(Boolean);
      acs.forEach(function (a) {
        var ba = a.b, m = a.m;
        cota(new V(ba.min.x, ba.min.y - 40, ba.max.z + 20), new V(ba.max.x, ba.min.y - 40, ba.max.z + 20), new V(0, 18, 0), cm(m.l) + ' cm');
        var aDireita = acs.some(function (o) { return o !== a && o.m.a === m.a && Math.abs(o.b.min.y - ba.min.y) < 30 && o.b.min.x > ba.min.x; });
        if (m.a >= 5 && !aDireita) cota(new V(ba.max.x + 50, ba.min.y, ba.max.z), new V(ba.max.x + 50, ba.max.y, ba.max.z), new V(18, 0, 0), cm(m.a) + ' cm');
      });
      // as cubas de apoio: só o tamanho, em cima delas
      Object.keys(G).forEach(function (n) {
        if (!G[n].visible || !cubaG.test(n) || chaveAtual.indexOf('cuba-') === 0) return;
        var t = new THREE.Box3(); caixaDe(n, t);
        rotulo(new V((t.min.x + t.max.x) / 2, t.max.y + 30, (t.min.z + t.max.z) / 2), /plena/.test(n) ? 'Cuba 49 × 32 cm' : 'Cuba 35 × 35 cm');
      });
      while (cotaEls.length < COTAS.length) { var s = document.createElement('span'); s.className = 'p3d__cota'; palco.appendChild(s); cotaEls.push(s); }
      cotaEls.forEach(function (s, i) { s.textContent = COTAS[i] ? COTAS[i].t : ''; s.hidden = !COTAS[i]; });
    }
    var _m = new THREE.Vector3();
    function posCotas() {
      cotaEls.forEach(function (s, i) {
        var ok = vis.medidas && !vis.cano && COTAS[i]; s.hidden = !ok; if (!ok) return;
        _m.copy(COTAS[i].p).project(cam);
        s.style.transform = 'translate(' + ((_m.x + 1) / 2 * palco.clientWidth).toFixed(1) + 'px,' + ((1 - _m.y) / 2 * palco.clientHeight).toFixed(1) + 'px) translate(-50%,-50%)';
      });
    }

    // encanamento: o cano sai do ralo, faz o sifão e vai para a parede ou o chão.
    // O móvel fica transparente e sem os riscos de dentro; a câmera fecha no cano.
    var canos = new THREE.Group(); canos.visible = false; cena.add(canos);
    var matCano = new THREE.MeshStandardMaterial({ color: 0xb7bec5, roughness: .36, metalness: .3 });
    var saidas = { parede: new THREE.Group(), chao: new THREE.Group() }; canos.add(saidas.parede); canos.add(saidas.chao);
    function tubo(pts, grp) {
      var c = new THREE.CatmullRomCurve3(pts, false, 'centripetal', .5);
      var m = new THREE.Mesh(new THREE.TubeGeometry(c, 140, 19, 14, false), matCano); m.castShadow = true; grp.add(m);
    }
    // a saída na parede ou no chão: uma canopla fina, rente
    function aro(pos, eixo, grp) {
      var m = new THREE.Mesh(new THREE.CylinderGeometry(36, 36, 5, 32), matCano);
      m.position.copy(pos); if (eixo === 'z') m.rotation.x = Math.PI / 2; grp.add(m);
    }
    // v195: o cano desce reto e faz uma curva só, sem voltas: para a parede, uma curva de 90° e
    // entra; para o chão, se precisar ir para trás, um desvio suave e desce reto até o piso
    function refazCanos() {
      [saidas.parede, saidas.chao].forEach(function (g) { while (g.children.length) { var o = g.children.pop(); o.geometry.dispose(); } });
      achaRalos();
      var b = corpoBox(true); if (!RALOS.length || b.isEmpty()) return;
      var V = THREE.Vector3, atras = b.min.z, C = D.cano || {}, R = 70;
      RALOS.forEach(function (r) {
        var x = r.x, y = r.y, z = r.z, ys = C.canal ? y - 150 : y - 195;
        var pp = [new V(x, y, z), new V(x, ys + R + 20, z)];
        [0, 30, 60, 90].forEach(function (g) { var t = g * Math.PI / 180; pp.push(new V(x, ys + R - R * Math.sin(t), z - R + R * Math.cos(t))); });
        pp.push(new V(x, ys, (z - R + atras) / 2), new V(x, ys, atras - 30));
        tubo(pp, saidas.parede);
        aro(new V(x, ys, atras + 2), 'z', saidas.parede);
        var zc = C.canal ? atras + 34 : (C.z != null ? C.z : atras + (C.fundo || 40)), yd = C.canal ? y - 160 : y - 70;
        var pc = [new V(x, y, z), new V(x, yd + 10, z), new V(x, yd - 30, z + (zc - z) * .25), new V(x, yd - 60, z + (zc - z) * .75), new V(x, yd - 90, zc), new V(x, (yd - 90) / 2, zc), new V(x, -1, zc)];
        tubo(pc, saidas.chao);
        aro(new V(x, 2, zc), 'y', saidas.chao);
      });
    }
    achaRalos();
    var DENTRO = /^(gav|gav_interna|prateleira_br|encosto|trav|divisoria|fundo_nicho|frente|pux|porta|tampo15|tampo)/;
    var FANT = ['mdf', 'frt', 'tmp', 'int', 'acb', 'mad', 'met', 'det', 'vid'], fantAntes = null, escondidos = [];
    function fantasma(liga) {
      if (liga && !fantAntes) {
        fantAntes = FANT.map(function (k) { var m = MATS[k]; return m ? [m, m.transparent, m.opacity, m.depthWrite] : null; });
        fantAntes.forEach(function (x) { if (!x) return; x[0].transparent = true; x[0].opacity = .1; x[0].depthWrite = false; x[0].needsUpdate = true; });
        fantAntes.push([linhaMat, linhaMat.transparent, linhaMat.opacity, linhaMat.depthWrite]); linhaMat.opacity = .09;
        // v193: o móvel aparece inteiro e suave (gavetas, portas, prateleiras), para ver que o cano
        // passa sem atrapalhar; só as peças de cima e a TV saem, porque a câmera fecha embaixo
        Object.keys(G).forEach(function (n) {
          if (G[n].visible && (/^ac\d*_/.test(n) || /(^tv$|_tv$)/.test(n))) { escondidos.push(n); G[n].visible = false; }
        });
      } else if (!liga && fantAntes) {
        fantAntes.forEach(function (x) { if (!x) return; x[0].transparent = x[1]; x[0].opacity = x[2]; x[0].depthWrite = x[3]; x[0].needsUpdate = true; });
        fantAntes = null; escondidos.forEach(function (n) { G[n].visible = true; }); escondidos = [];
      }
    }
    function aplicaCano() {
      if (vis.cano) refazCanos();
      canos.visible = vis.cano; saidas.parede.visible = vis.saida === 'parede'; saidas.chao.visible = vis.saida === 'chao';
      fantasma(vis.cano); raiz.classList.toggle('p3d--cano', vis.cano); cotas.visible = vis.medidas && !vis.cano;
      if (vis.cano) {
        // a câmera fecha no cano: da cuba até o chão ou a parede, com folga dos lados
        var f = new THREE.Box3().setFromObject(vis.saida === 'chao' ? saidas.chao : saidas.parede);
        Object.keys(G).forEach(function (n) { if (G[n].visible && cubaG.test(n) || n === 'pia') { var t = new THREE.Box3(); caixaDe(n, t); f.union(t); } });
        f.expandByVector(new THREE.Vector3(140, 60, 140)); focoCaixa = f;
      } else focoCaixa = null;
      giroAlvo = vis.cano ? 40 : 0; precisa = true;
    }

    // cubas: os nomes curtos de cada versão do modelo
    var NOMES_CFG = { pia: 'Pia de embutir', chanel: 'Cuba Chanel', chanel1: '1 cuba Chanel', chanel2: '2 cubas Chanel', plena1: '1 cuba plena', plena2: '2 cubas plenas', tampo: 'Só tampo', nada: 'Sem tampo' };
    var ehPrat = /^prateleira-/.test(chaveAtual);
    function nomeKit(s) {
      if (ehPrat) return (s ? s.split('+').length + 1 : 1) + (s ? ' prateleiras' : ' prateleira');
      if (!s) { var pri = ((raiz.getAttribute('data-nome') || D.nome || '').split(' ')[0] || '').toLowerCase(); return pri ? 'Só o ' + pri : 'Só a peça'; }
      var k = s.split('+')[0].split('@')[0].split('#')[0];
      if (/^armario/.test(k)) return /\+/.test(s) ? '2 armários' : 'Armário';
      if (/^espelheira-led/.test(k)) return 'Espelho com LED';
      if (/^espelheira-redonda/.test(k)) return 'Espelho redondo';
      if (/^espelho-organico/.test(k)) return 'Espelho orgânico';
      if (/^espelheira-paris|^espelheira-moscou/.test(k)) return 'Espelheira';
      if (/^espelho-dubai/.test(k)) return 'Espelho';
      if (/^dallas-painel/.test(k)) return /prateleira/.test(s) ? 'Painel e prateleira' : 'Painel';
      if (/^prateleira/.test(k)) return 'Prateleira';
      return k;
    }
    function trocaPara(t, novoCfg, novoKit) {
      var cfgs = (t.cfgs || '').split(','), cores = (t.cores || '').split(',');
      var nc = cfgs.indexOf(novoCfg) > -1 ? novoCfg : (novoCfg === 'tampo' && cfgs.indexOf('nada') > -1 ? 'nada'
        : (/^chanel/.test(novoCfg) && cfgs.indexOf('chanel') > -1 ? 'chanel' : (novoCfg === 'chanel' && cfgs.indexOf('chanel1') > -1 ? 'chanel1' : cfgs[0])));
      var nk = cores.indexOf(corAtual) > -1 ? corAtual : cores[0];
      var kitObj = (t.kits || []).filter(function (x) { return x.s === novoKit; })[0];
      guardaVis();
      raiz.setAttribute('data-kit-spec', kitObj ? kitObj.s : '');
      trocaModelo({ k: t.k, u: t.u, kit: kitObj ? kitObj.p : [], n: t.n, cfg: nc, cor: nk, cores: t.cores });
    }

    // o link para o anúncio da combinação montada (só quando o produto existe)
    var linkEl = null;
    function chaveAnuncio() { return chaveAtual + '|' + corAtual + '|' + cfg + '|' + kitSpec; }
    function marcaAnuncio() {
      if (raiz.__preparaARh) raiz.__preparaARh();
      if (!linkEl) return;
      var A = window.ONM3D_ANUNCIOS, igualPagina = chaveAtual === raiz.getAttribute('data-chave-original') && corAtual === raiz.getAttribute('data-cor-original') &&
        cfg === raiz.getAttribute('data-config-original') && kitSpec === raiz.getAttribute('data-kit-original');
      if (igualPagina || !A) { linkEl.innerHTML = ''; linkEl.hidden = true; return; }
      var h = A[chaveAnuncio()], zap = raiz.getAttribute('data-zap');
      if (h && h !== raiz.getAttribute('data-handle')) linkEl.innerHTML = '<a href="/products/' + h + '">Ver anúncio desta configuração<span aria-hidden="true"> →</span></a>';
      else if (!h && zap) linkEl.innerHTML = '<span>Essa combinação não tem anúncio pronto.</span> <a href="' + zap + '" target="_blank" rel="noopener nofollow" data-zap="3d">Falar com a gente</a>';
      else linkEl.innerHTML = '';
      linkEl.hidden = !linkEl.innerHTML;
    }
    function carregaAnuncios() {
      if (window.ONM3D_ANUNCIOS) { marcaAnuncio(); return; }
      var u = raiz.getAttribute('data-anuncios'); if (!u || raiz.__anunciosPedido) return;
      raiz.__anunciosPedido = true; carrega(u).then(function () { if (!morto) marcaAnuncio(); }).catch(function () {});
    }

    // as linhas de opções
    var opcH = '', linhaH = function (rot, corpo) { return '<div class="p3d__lin"><span class="p3d__rot">' + rot + '</span><div class="p3d__chips">' + corpo + '</div></div>'; };
    if (TAMS.length > 1) opcH += linhaH('Medida', TAMS.map(function (t) { return '<button type="button" data-tam="' + t.k + '" aria-pressed="' + (t.k === chaveAtual) + '">' + t.w + '</button>'; }).join('') + '<i>cm</i>');
    var ORDEM_CFG = ['pia', 'chanel', 'chanel1', 'chanel2', 'plena1', 'plena2', 'tampo', 'nada'];
    var cfgsM = Object.keys(CONF).filter(function (c) { return c !== 'unico'; }).sort(function (a, b) { return ORDEM_CFG.indexOf(a) - ORDEM_CFG.indexOf(b); });
    if (cfgsM.length > 1) opcH += linhaH('Cuba', cfgsM.map(function (c) { return '<button type="button" data-cfg="' + c + '" aria-pressed="' + (c === cfg) + '">' + (NOMES_CFG[c] || c) + '</button>'; }).join(''));
    if (tamAtual && tamAtual.kits && tamAtual.kits.length) {
      opcH += linhaH(ehPrat ? 'Quantas' : 'Conjunto', ['<button type="button" data-kit="" aria-pressed="' + (!kitSpec) + '">' + nomeKit('') + '</button>'].concat(tamAtual.kits.map(function (k) {
        return '<button type="button" data-kit="' + k.s.replace(/"/g, '&quot;') + '" aria-pressed="' + (k.s === kitSpec) + '">' + nomeKit(k.s) + '</button>';
      })).join(''));
    }
    // v206: textos de ação, e o encanamento logo depois do ambiente (é o que mais tira dúvida no banheiro)
    // v207: ambiente, pés, encanamento, medidas, inverter a porta. Parede/chão do esgoto aparecem
    // na mesma fileira quando o encanamento está ligado (a altura do menu não muda)
    var vbt = (PES.length ? '<button type="button" data-vis="pes" aria-pressed="false">' + (vis.pes ? 'Ver suspenso' : 'Ver com pés') + '</button>' : '') +
      (RALOS.length ? '<button type="button" data-vis="cano" aria-pressed="false">Ver encanamento</button>' +
        '<button type="button" data-saida="parede" data-p3d-esgoto hidden aria-pressed="' + (vis.saida === 'parede') + '">Esgoto na parede</button>' +
        '<button type="button" data-saida="chao" data-p3d-esgoto hidden aria-pressed="' + (vis.saida === 'chao') + '">Esgoto no chão</button>' : '') +
      '<button type="button" data-vis="medidas" aria-pressed="' + vis.medidas + '">Ver medidas</button>';
    var KIT = raiz.__kit || [], umaPorta = function (k) { return k === 'armario-60'; };
    var temUmaPorta = umaPorta(chaveAtual) || KIT.some(function (k) { return umaPorta(k.k); });
    if (temUmaPorta) vbt += '<button type="button" data-inverte>Inverter a porta</button>';
    var nomeAmb = function () { return (AMBS.filter(function (a) { return a[0] === vis.amb; })[0] || AMBS[0] || ['', ''])[1]; };
    if (AMBS.length > 1) vbt = '<button type="button" data-amb aria-pressed="' + (vis.amb !== 'estudio') + '">Trocar ambiente</button>' + vbt;
    opcH += linhaH('Ver', vbt);

    opcH += '<small class="p3d__nota" data-p3d-nota-pes hidden></small>';
    opcH += '<p class="p3d__anuncio" data-p3d-anuncio hidden></p>';
    opcEl.innerHTML = opcH;
    ctrl.parentNode.insertBefore(opcEl, ctrl.nextSibling);
    linkEl = opcEl.querySelector('[data-p3d-anuncio]');
    if (window.matchMedia && matchMedia('(max-width: 999px)').matches) {
      var topoEl = raiz.querySelector('.p3d__topo'); if (topoEl && linkEl) { topoEl.appendChild(linkEl); raiz.__linkFora = linkEl; }
    }
    var notaPes = opcEl.querySelector('[data-p3d-nota-pes]'), sub = opcEl.querySelector('[data-p3d-sub]'), ambsEl = opcEl.querySelector('[data-p3d-ambs]');
    (function verPrimeiro() {
      var lv = Array.prototype.filter.call(opcEl.querySelectorAll('.p3d__lin'), function (l) { return (l.querySelector('.p3d__rot') || {}).textContent === 'Ver'; })[0];
      if (!lv) return;
      var ref = opcEl.firstChild;
      [lv, ambsEl, sub].forEach(function (el) { if (el) opcEl.insertBefore(el, ref); });
      // as que vêm depois do Ver (no lugar onde ele estava) seguem a ordem de antes
    })();
    /* v203 · celular: menos texto em cima do 3D. As linhas de escolha viram abas
       (Cor, Medida, Cuba, Em cima, Ver) e só a da aba escolhida aparece, numa linha.
       Nada some: tudo continua a um toque. A aba fica a mesma quando troca a medida. */
    var CELULAR = window.matchMedia && matchMedia('(max-width: 999px)').matches;
    if (CELULAR) (function abas() {
      var lins = Array.prototype.slice.call(opcEl.querySelectorAll('.p3d__lin'));
      if (caixaCores && caixaCores.children.length > 1) {
        var lc = document.createElement('div'); lc.className = 'p3d__lin p3d__lin--cor';
        lc.innerHTML = '<span class="p3d__rot">Cor</span><div class="p3d__chips"></div>';
        raiz.__paiCores = caixaCores.parentNode; lc.querySelector('.p3d__chips').appendChild(caixaCores);
        var lv0 = lins.filter(function (l) { return (l.querySelector('.p3d__rot') || {}).textContent === 'Ver'; })[0];
        if (lv0) { lins.splice(lins.indexOf(lv0) + 1, 0, lc); var dep = sub || ambsEl || lv0; opcEl.insertBefore(lc, dep.nextSibling); } else { opcEl.insertBefore(lc, opcEl.firstChild); lins.unshift(lc); }
      }
      if (lins.length < 2) return;
      var barraAbas = document.createElement('div'); barraAbas.className = 'p3d__abas'; barraAbas.setAttribute('role', 'tablist');
      lins.forEach(function (l) {
        var r = (l.querySelector('.p3d__rot') || {}).textContent || ''; l.setAttribute('data-aba', r); l.setAttribute('role', 'tabpanel');
        var bt = document.createElement('button'); bt.type = 'button'; bt.setAttribute('role', 'tab'); bt.setAttribute('data-aba-bt', r); bt.textContent = r; barraAbas.appendChild(bt);
      });
      opcEl.insertBefore(barraAbas, opcEl.firstChild); raiz.classList.add('p3d--abas');
      function rolagem(el) {
        var lin = el.parentNode; if (!lin || el.__marca) return;
        var mais = document.createElement('button'); mais.type = 'button'; mais.className = 'p3d__rola'; mais.setAttribute('aria-label', 'Ver mais opções');
        mais.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>'; lin.appendChild(mais);
        function marca() {
          var fim = el.scrollWidth - el.clientWidth - el.scrollLeft;
          el.classList.toggle('p3d--maisdir', fim > 4); el.classList.toggle('p3d--maisesq', el.scrollLeft > 4); mais.hidden = !(fim > 4);
        }
        liga(el, 'scroll', marca, { passive: true });
        liga(mais, 'click', function (e) { e.stopPropagation(); el.scrollBy({ left: el.clientWidth * .6, behavior: 'smooth' }); });
        el.__marca = marca; marca();
      }
      function cutuca(el) {
        if (!el || el.__cutucou || REDUZ || el.scrollWidth - el.clientWidth < 12) return;
        el.__cutucou = true;
        seq.push(setTimeout(function () { el.scrollTo({ left: 64, behavior: 'smooth' }); }, 900));
        seq.push(setTimeout(function () { el.scrollTo({ left: 0, behavior: 'smooth' }); }, 1700));
      }
      function mostra(a) {
        if (!lins.some(function (l) { return l.getAttribute('data-aba') === a; })) a = lins[0].getAttribute('data-aba');
        raiz.setAttribute('data-aba', a);
        lins.forEach(function (l) { l.hidden = l.getAttribute('data-aba') !== a; });
        Array.prototype.forEach.call(barraAbas.children, function (bt) { bt.setAttribute('aria-selected', bt.getAttribute('data-aba-bt') === a); });
        var ver = a === 'Ver';
        if (notaPes) notaPes.classList.toggle('p3d--fora', !ver);
        if (sub) sub.classList.toggle('p3d--fora', !ver);
        if (ambsEl) ambsEl.classList.toggle('p3d--fora', !ver);
        lins.forEach(function (l) { var ch = l.querySelector('.p3d__chips'); if (ch && !l.hidden) { rolagem(ch); ch.__marca(); if (ver && l.getAttribute('data-aba') === 'Ver' && !raiz.__cutucouVer) { raiz.__cutucouVer = true; cutuca(ch); } } });
        precisa = true;
      }
      liga(barraAbas, 'click', function (e) { var bt = e.target.closest('[data-aba-bt]'); if (bt) { usou(); mostra(bt.getAttribute('data-aba-bt')); } });
      mostra(raiz.getAttribute('data-aba') || lins[0].getAttribute('data-aba'));
    })();
    function marcaPes() {
      if (notaPes) notaPes.hidden = true;   // v207: o aviso aparece na tela quando a pessoa toca em "Ver com pés"/"Ver suspenso" 
      var b = opcEl.querySelector('[data-vis="pes"]'); if (b) b.textContent = vis.pes ? 'Ver suspenso' : 'Ver com pés';
    }
    /* v196: o "Ver na minha casa" fica sempre. Ele abre o arquivo 3D do anúncio da combinação
       montada; sem anúncio igual, o mais parecido (mesma medida e cor, depois mesma medida);
       sem nenhum, o da própria página. */
    raiz.__arAlvo = function () {
      var A = window.ONM3D_ANUNCIOS; if (!A) return null;
      var h = A[chaveAnuncio()]; if (h) return h;
      var ks = Object.keys(A), acha = function (f) { for (var i = 0; i < ks.length; i++) { var q = ks[i].split('|'); if (f(q)) return A[ks[i]]; } return null; };
      return acha(function (q) { return q[0] === chaveAtual && q[1] === corAtual && q[2] === cfg; })
        || acha(function (q) { return q[0] === chaveAtual && q[1] === corAtual && q[3] === kitSpec; })
        || acha(function (q) { return q[0] === chaveAtual && q[1] === corAtual; })
        || acha(function (q) { return q[0] === chaveAtual && q[2] === cfg && q[3] === kitSpec; })
        || acha(function (q) { return q[0] === chaveAtual; });
    };
    liga(opcEl, 'click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      usou();
      if (b.hasAttribute('data-tam')) {
        var k = b.getAttribute('data-tam'); if (k === chaveAtual) return;
        var t = TAMS.filter(function (x) { return x.k === k; })[0]; if (!t) return;
        // a mesma peça de cima na outra medida (mesmo tipo), se ela existir lá
        var tipo = nomeKit(kitSpec), alvoK = kitSpec ? ((t.kits || []).filter(function (x) { return nomeKit(x.s).replace('2 armários', 'Armário') === tipo.replace('2 armários', 'Armário'); })[0] || {}).s || '' : '';
        if (kitSpec && !alvoK && t.ks) alvoK = t.ks;
        trocaPara(t, cfg, alvoK); return;
      }
      if (b.hasAttribute('data-inverte')) {
        // a mesma montagem com a(s) porta(s) abrindo para o outro lado, já aberta(s) para ver
        var nk = KIT.map(function (k) { var c = JSON.parse(JSON.stringify(k)); if (umaPorta(c.k)) c.e = c.e ? 0 : 1; return c; });
        var tA = tamAtual || { k: chaveAtual, u: raiz.getAttribute('data-modelo'), n: raiz.getAttribute('data-nome'), cores: raiz.getAttribute('data-cores') };
        guardaVis(); raiz.__abrir = true;
        trocaModelo({ k: chaveAtual, u: tA.u || raiz.getAttribute('data-modelo'), kit: nk, n: raiz.getAttribute('data-nome') || tA.n, cfg: cfg, cor: corAtual, cores: raiz.getAttribute('data-cores') || tA.cores, espelha: umaPorta(chaveAtual) ? !raiz.__espelha : !!raiz.__espelha });
        return;
      }
      if (b.hasAttribute('data-kit')) {
        var ks = b.getAttribute('data-kit'); if (ks === kitSpec || !tamAtual) return;
        trocaPara(tamAtual, cfg, ks); return;
      }
      if (b.hasAttribute('data-cfg')) {
        var nc = b.getAttribute('data-cfg'); if (nc === cfg) return;
        if (vis.cano) { vis.cano = false; aplicaCano(); var bc = opcEl.querySelector('[data-vis="cano"]'); if (bc) bc.setAttribute('aria-pressed', 'false'); if (sub) sub.hidden = true; }
        cfg = nc; raiz.setAttribute('data-config', cfg);
        ESCONDE = {}; (CONF[cfg] || []).forEach(function (g) { ESCONDE[g] = true; });
        Object.keys(G).forEach(function (n) { if (/^ac\d*_/.test(n) || /^pe_/.test(n)) return; G[n].visible = !ESCONDE[n]; });
        Array.prototype.forEach.call(opcEl.querySelectorAll('[data-cfg]'), function (x) { x.setAttribute('aria-pressed', x === b); });
        achaRalos(); var bc2 = opcEl.querySelector('[data-vis="cano"]'); if (bc2) bc2.hidden = !RALOS.length;
        montaCotas(); marcaAnuncio(); precisa = true; return;
      }
      var v = b.getAttribute('data-vis');
      if (v === 'medidas') { vis.medidas = !vis.medidas; cotas.visible = vis.medidas && !vis.cano; b.setAttribute('aria-pressed', vis.medidas); precisa = true; }
      else if (v === 'pes') {
        vis.pes = !vis.pes; aplicaPes(); marcaPes(); if (vis.amb !== 'estudio') aplicaAmbiente();
        avisa(D.pesOpcional ? 'Pode ser instalado suspenso ou com pés. Você escolhe na hora de montar' : (vis.pes ? 'Os pés são vendidos à parte' : ''));
      }
      else if (b.hasAttribute('data-amb')) {
        // v205: cada toque passa para o próximo ambiente, e o nome aparece no próprio botão
        var ia = 0; AMBS.forEach(function (a, i) { if (a[0] === vis.amb) ia = i; });
        vis.amb = AMBS[(ia + 1) % AMBS.length][0]; aplicaAmbiente();
        b.setAttribute('aria-pressed', vis.amb !== 'estudio');
        avisa(vis.amb === 'estudio' ? 'Sem ambiente' : 'Ambiente ' + nomeAmb() + (raiz.__trocouAmb ? '' : ' · toque de novo para outro')); raiz.__trocouAmb = true;
      }
      else if (v === 'cano') {
        vis.cano = !vis.cano; b.setAttribute('aria-pressed', vis.cano); aplicaCano();
        Array.prototype.forEach.call(opcEl.querySelectorAll('[data-p3d-esgoto]'), function (x) { x.hidden = !vis.cano; });
        if (vis.cano) avisa('Serve para esgoto na parede e no chão');
        var fil = b.parentNode; if (fil && fil.__marca) setTimeout(fil.__marca, 30);
      }
      else if (b.hasAttribute('data-saida')) {
        vis.saida = b.getAttribute('data-saida');
        Array.prototype.forEach.call(opcEl.querySelectorAll('[data-saida]'), function (x) { x.setAttribute('aria-pressed', x === b); });
        aplicaCano();
      }
      guardaVis();
    });
    // a cor trocada também muda o anúncio da combinação
    liga(caixaCores, 'click', function () { setTimeout(marcaAnuncio, 0); });
    if (PES.length && (vis.pes !== !!D.pesOpcional || D.pesVendidos)) aplicaPes();
    if (vis.amb !== 'estudio') aplicaAmbiente();
    montaCotas(); marcaPes(); carregaAnuncios();
    if (vis.medidas) cotas.visible = true;
    // depois de trocar: sem a apresentação de novo, móvel fechado
    if (raiz.__trocou) { emCena = true; tocou = true; for (var s0 = 1; s0 <= NP; s0++) { cur.g[s0] = 0; alvo.g[s0] = 0; } cur.ga = 0; marcaModo(); }
    if (raiz.__abrir) { raiz.__abrir = false; seq.push(setTimeout(function () { for (var s1 = 1; s1 <= NP; s1++) alvo.g[s1] = 1; marcaModo(); precisa = true; }, 350)); }

    // desmonta tudo o que esta montagem ligou, para a troca de medida
    raiz.__destroi = function () {
      morto = true; vivo = false;
      LIGS.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
      OBS.forEach(function (o) { o.disconnect(); });
      seq.forEach(clearTimeout); clearTimeout(avisoT); clearTimeout(ativoT);
      // as cores voltam para o lugar delas antes de a linha de escolhas sair (v203: no celular elas moram na aba Cor)
      if (raiz.__paiCores && caixaCores && opcEl.contains(caixaCores)) raiz.__paiCores.appendChild(caixaCores);
      if (raiz.__linkFora && raiz.__linkFora.parentNode) raiz.__linkFora.parentNode.removeChild(raiz.__linkFora);
      raiz.classList.remove('p3d--abas');
      if (ambGrupo) { cena.remove(ambGrupo); ambGrupo.traverse(function (o) { if (o.geometry) o.geometry.dispose(); if (o.material) o.material.dispose(); }); ambGrupo = null; }
      [opcEl, alvoEl, tvEl, tvsEl].concat(cotaEls).forEach(function (el) { if (el && el.parentNode) el.parentNode.removeChild(el); });
      fantasma(false); linhaMat.opacity = .16;
      cena.traverse(function (o) { if (o.geometry) o.geometry.dispose(); });
      if (rend.domElement.parentNode) rend.domElement.parentNode.removeChild(rend.domElement);
      rend.dispose();
      raiz.classList.remove('p3d--usou', 'p3d--dica', 'p3d--sair', 'p3d--cano');
      html.classList.remove('p3dFoco');
    };

    // usado só para gerar as imagens de reserva de cada cor
    window.ONM3D_PRONTO = texPronta;
    window.ONM3D_FOTO = function (cor, conf) {
      if (cor) aplicaCor(cor);
      if (conf && CONF[conf]) { var esc = {}; CONF[conf].forEach(function (g) { esc[g] = true; }); Object.keys(G).forEach(function (n) { G[n].visible = !esc[n] && !(D.pesVendidos && /^pe_/.test(n)); }); }
      // v182: a distância recomeça do zero, senão o plano de corte da câmera ficava na
      // distância da vista anterior e cortava a frente do móvel na imagem
      var st = { g: [0, 0, 0, 0, 0, 0, 0, 0], ex: 0, ga: 0 }; aplica(st); dist = 0; enquadra(true, true);
      var az = 24 * Math.PI / 180, el = 14 * Math.PI / 180;
      cam.position.set(centro.x + Math.sin(az) * Math.cos(el) * dist, centro.y + Math.sin(el) * dist, centro.z + Math.cos(az) * Math.cos(el) * dist);
      cam.lookAt(centro); rend.render(cena, cam); return rend.domElement.toDataURL('image/png');
    };
  }
})();
